var GENERAL_ACTIVE_MAIN_CONFIG_COLUMN = [{
        label: "活动主题",
        type: "input", // 控件类型
        field: "ActivityName", // 字段名
        readOnly: true,
    },
    {
        label: "活动类型",
        type: "input", // 控件类型
        field: "ActiveTypeHidden", // 字段名
        readOnly: true,
    },
    {
        label: "活动形式",
        type: "input", // 控件类型
        field: "ActivityParton", // 字段名
        readOnly: true,
    },
    
    {
        label: "封面图片",
        type: "upload", // 控件类型
        field: "FaceImage", // 字段名
        readOnly: true,
    },
    {
        label: "报名对象",
        type: "checkbox", // 控件类型
        field: "suibian", // 字段名
        readOnly: true,
        option: [{
                label: '会员',
                field: 'MemberObject'
            },
            {
                label: '预备会员',
                field: 'PreMemberObject'
            },
            {
                label: '家属',
                field: 'FamilyObject'
            },
            {
                label: '受邀人员',
                field: 'InviteeObject'
            },
        ],
        col:24
    },
    {
        label: "活动开始时间",
        type: "input", // 控件类型
        field: "StartTime", // 字段名
        readOnly: true,
    },
    {
        label: "活动结束时间",
        type: "input", // 控件类型
        field: "EndTime", // 字段名
        readOnly: true,
    },
    {
        label: "报名开始时间",
        type: "input", // 控件类型
        field: "SignUpStartTime", // 字段名
        readOnly: true,
    },
    {
        label: "报名结束时间",
        type: "input", // 控件类型
        field: "SignUpEndTime", // 字段名
        readOnly: true,
    },
    
    {
        label: "受邀人员",
        type: "input", // 控件类型
        field: "syry", // 字段名
        readOnly: true,
        dataAsync: {
            action: "/MobileApis/ActivityHandler.ashx?action=GetInvitee",
            type: "受邀人员"
        },
        if: "this.form.InviteeObject == 'on'"
    },
    {
        label: "家属报名提醒内容",
        type: "richText", // 控件类型
        field: "FamilyReminder", // 字段名
        readOnly: true,
        if: "this.form.FamilyObject == 'on'",
    },
    {
        label: "开启家属报名提醒",
        type: "select", // 控件类型
        field: "IsRemind", // 字段名
        readOnly: true,
        if: "this.form.FamilyObject == 'on'",
        option: [{ // 下拉数据
                label: '开',
                value: 'on',
            },
            {
                label: '关',
                value: 'off'
            },
        ]
    },
    {
        label: "活动管理员",
        type: "input", // 控件类型
        field: "ActivityManager", // 字段名
        readOnly: true,
    },
    {
        label: "协助管理员",
        type: "input", // 控件类型
        field: "OtherManager", // 字段名
        readOnly: true,
    },
    {
        label: "活动介绍",
        type: "richText", // 控件类型
        field: "Intraduction", // 字段名
        readOnly: true,
    },
    {
        label: "活动摘要",
        type: "input", // 控件类型
        field: "Summary", // 字段名
        readOnly: true,
    },
    {
        label: "城市选择",
        type: "input", // 控件类型
        field: "City", // 字段名
        readOnly: true,
    },
    {
        label: "部门选择",
        type: "input", // 控件类型
        field: "Depart", // 字段名
        readOnly: true,
    },
    {
        label: "小组选择",
        type: "input", // 控件类型
        field: "GroupName", // 字段名
        readOnly: true,
    },
    {
        label: "通知设置",
        type: "input", // 控件类型
        field: "MessageSetName", // 字段名
        readOnly: true,
    },
    {
        label: "发布时间",
        type: "input", // 控件类型
        field: "PushTime", // 字段名
        readOnly: true,
        if: "!this.form.ReleaseNow || this.form.ReleaseNow == 'off'"
    },
    {
        label: "立即发布",
        type: "checkbox", // 控件类型
        field: "suibian1", // 字段名
        readOnly: true,
        if: "this.form.ReleaseNow == 'on'",
        option: [{
            label: '是',
            field: 'ReleaseNow'
        }, ]
    },
    // {
    //   label: "提醒选项",
    //   type: "checkbox", // 控件类型
    //   field: "suibian1", // 字段名
    //   readOnly: true,
    //   if: "this.form.FamilyObject == 'on'",
    //   option: [{
    //     label: '是否家属提醒',
    //     field: 'IsRemind'
    //   }, ]
    // },

]
var CLONE_GENERAL_ACTIVE_MAIN_CONFIG_COLUMN = JSON.parse(JSON.stringify(GENERAL_ACTIVE_MAIN_CONFIG_COLUMN));
var confirmHtml = `
使用本站的服务即表示您同意本站可以按照我们的隐私权政策使用您的个人数据。

收集信息的目的：
我们收集信息是为了向所有用户提供更好的服务，这既包括获取一些基本的信息（例如您使用的语言），也包括更为复杂的信息（例如工会福利及补助发放等）。

我们有两种信息收集方式：
您向我们提供信息。一些服务要求您注册帐户。而在您注册帐户时，我们会要求您提供个人信息，例如您的姓名、电子邮件地址、电话号码。如果您想要充分利用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中会包含您的姓名和照片。
我们在您使用服务的过程中获取信息。我们会收集关于您使用的服务以及使用方式的信息，例如您在何时访问了使用我们的的网站，或者您在何时查看了我们的平台和内容并与之互动。此类信息包括：设备信息、日志信息、位置信息、本地存储、Cookie 和匿名标识符。

使用收集到的信息：
我们利用从所有服务中收集的信息来提供、维护、保护和改进这些服务，同时开发新的服务并保护本站以及用户。我们还会使用此类信息为您提供定制内容。
我们不会与本站以外的任何公司、组织和个人分享用户的个人信息，但是以下情况除外：征得您的同意；出于法律原因。

信息安全：
我们努力为用户提供保护，以免我们保存的信息在未经授权的情况下被访问、篡改、披露或破坏。
我们只允许那些为了帮我们处理个人信息而需要知晓这些信息的员工、承包商和代理商访问个人信息，而且他们需要履行严格的合同保密义务，如果其未能履行这些义务，就可能会被追究法律责任。

变更：
我们的隐私权政策随时都可能变更。未经您明确同意，我们不会削减您按照本隐私权政策所应享有的权利。我们会在本页面上发布对隐私权政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知。
`
const OPTION_JF_FORM = {
    工会费用银行付款申请: {
        allSubmit: true,
        shortTitle: "工会费用银行付款申请",
        config: [{
          name: "工会费用银行付款申请",
          tabText: "工会费用银行付款申请",
          action: {},
          mainForm: true,
          shortTitle: "工会费用银行付款申请",
          column: [
            {
              label: "申请人姓名",
              type: "input", // 控件类型
              field: "AppName", // 字段名
              readOnly: true
            },
            {
              label: "所在城市",
              type: "input", // 控件类型
              field: "AppCity", // 字段名
              readOnly: true
            },
            {
              label: "所在部门",
              type: "input", // 控件类型
              field: "AppDepartment", // 字段名
              readOnly: true
            },
            {
              label: "收款人",
              type: "input", // 控件类型
              field: "Payee", // 字段名
              readOnly: true
            },
            {
              label: "金额(小写)",
              type: "input", // 控件类型
              field: "AppMoney", // 字段名
              readOnly: true
            },
            {
              label: "金额(大写)",
              type: "input", // 控件类型
              field: "AppMoney1", // 字段名
              readOnly: true
            },
            {
              label: "开户银行",
              type: "input", // 控件类型
              field: "Bank", // 字段名
              readOnly: true
            },
            {
              label: "账号",
              type: "input", // 控件类型
              field: "BankAC", // 字段名
              readOnly: true
            },
            {
              label: "事由",
              type: "textarea", // 控件类型
              field: "Reason", // 字段名
              readOnly: true
            },
            {
              label: "备注类别",
              type: "input", // 控件类型
              field: "Notes", // 字段名
              readOnly: true
            },
            {
              label: "申请日期",
              type: "input", // 控件类型
              field: "CreateTime", // 字段名
              readOnly: true
            },
            {
              label: "请确认申请材料是否齐全",
              type: "checkboxArr", // 控件类型
              field: "AppMaterials", // 字段名
              readOnly: true,
              option: [
                {
                    label: '活动协议/合同',
                    field: '1'
                },
                {
                    label: '参与人签到表',
                    field: '2'
                },
                {
                    label: '礼品签收表',
                    field: '3'
                    },
                {
                    label: '发票及明细',
                    field: '4'
                },
                {
                    label: '活动照片',
                    field: '5'
                },
                {
                    label: '活动分享小结',
                    field: '6'
                },
                {
                    label: '其他必要资料',
                    field: '7'
                },
              ]
            },
            {
              label: "申请材料",
              type: "upload2", // 控件类型
              field: "Annex", // 字段名
              readOnly: true,
            },
            {
              label: "注意事项",
              type: "textarea", // 控件类型
              field: "Note", // 字段名
              readOnly: true
            },
            {
              type: "table",
              required: true,
              model: [
                {
                    label:'日期',
                    field: 'PayTime',
                    type: 'input'
                },
                {
                    label:'报销人',
                    field: 'AppName',
                    type: 'input'
                },
                {
                    label:'费用类别',
                    field: 'TypeName',
                    type: 'input'
                },
                {
                    label:'金额',
                    field: 'AppMoney',
                    type: 'input'
                },
                {
                    label:'备注',
                    field: 'Remark',
                    type: 'input'
                }
              ],
              field:'data',
            }
          ]
          },
          {
            name: "工会费用银行付款明细表",
            tabText: "费用明细",
            ismx: true,
            detail: [{
                label:'日期',
                field: 'PayTime',
                type: 'input'
            },
            {
                label:'报销人',
                field: 'AppName',
                type: 'input'
            },
            {
                label:'费用类别',
                field: 'TypeName',
                type: 'input'
            },
            {
                label:'金额',
                field: 'AppMoney',
                type: 'input'
            },
            {
                label:'备注',
                field: 'Remark',
                type: 'input'
            }
            ]
          }
        ]
      },
      工会活动申请表: {
        allSubmit: true,
        shortTitle: "工会活动申请表",
        config: [{
          name: "工会活动申请表",
          tabText: "工会活动申请表",
          action: {},
          mainForm: true,
          shortTitle: "工会活动申请表",
          column: [
            {
              label: "活动类型",
              type: "input", // 控件类型
              field: "ActivityType", // 字段名
              readOnly: true
            },
            {
              label: "活动时间",
              type: "input", // 控件类型
              field: "ActivityTime", // 字段名
              readOnly: true
            },
            {
              label: "活动地点",
              type: "textarea", // 控件类型
              field: "Aclocation", // 字段名
              readOnly: true
            },
            {
              label: "申请人姓名",
              type: "input", // 控件类型
              field: "AppName", // 字段名
              readOnly: true
            },
            {
              label: "所在城市",
              type: "input", // 控件类型
              field: "AppCity", // 字段名
              readOnly: true
            },
            {
                label: "所在部门",
                type: "input", // 控件类型
                field: "AppDepartment", // 字段名
                readOnly: true
            },
            {
                label: "申请时间",
                type: "input", // 控件类型
                field: "CreateTime", // 字段名
                readOnly: true
            },
            {
              label: "申请事由",
              type: "textarea", // 控件类型
              field: "AppReason", // 字段名
              readOnly: true
            },
            {
              label: "申请金额",
              type: "input", // 控件类型
              field: "AppMoney", // 字段名
              readOnly: true
            },
            {
              label: "人数",
              type: "input", // 控件类型
              field: "AppNum", // 字段名
              readOnly: true
            },
            {
              label: "注意事项",
              type: "textarea", // 控件类型
              field: "Note", // 字段名
              readOnly: true
            },
            {
              label: "相关附件",
              type: "upload2", // 控件类型
              field: "Annex", // 字段名
              readOnly: true
            }
          ]
        }]
      },
    入会申请: {
        allSubmit: true,
        shortTitle: "入会申请审批表",
        slot: "入会申请",
        addRushTitle: "入会申请审批加催",
        button: {
            submit: { // 提交的方法
                text: "提交入会申请",
                action: "/MobileApis/MemberApplyHandler.ashx?action=AddMemberApply",
                success: {
                    popup: "success",
                    action: "back"
                },
                if: "this.newForm == true && this.formStatus != -2"
            },
        },
        edit: {
            action: "/MobileApis/MemberApplyHandler.ashx?action=UpdateMemberApply"
        },
        getOldDataAction: { // 获取原来单子的方法
            action: "/MobileApis/MemberApplyHandler.ashx?action=GetMemberApply"
        },
        status: { // 获取单子状态的方法
            action: "/MobileApis/MemberApplyHandler.ashx?action=GetMemberApplyStatus",
        },
        revocation: {
            action: "/MobileApis/MemberApplyHandler.ashx?action=CancelMemberApply",
        },
        getAutoDataAction: { // 新单子时获取自动获取数据的方法
            action: "/MobileApis/MemberHandler.ashx?action=GetMemberInfo",
            param: {
                shortTitle: "人员信息表",
                type: "rhsq",
            }

        },
        selfSpdingMessage: "信息审批中，请先撤回再修改",
        config: [{
                name: "jbxx", // 表单名称
                tabText: "会员信息",
                shortTitle: "入会申请审批表",
                mainForm: true,
                action: { // 接口交互
                    new: { // new接口
                        url: "/newform"
                    },
                    edit: { // edit接口
                        url: "/editForm"
                    }
                },
                column: [{
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "Code", // 字段名
                        // required: true, // 是否必填
                        requiredMessage: "未代入AD账号", // 没有填写的提示
                        // placeholder: "请输入AD账号",
                        // readOnly: true,
                        hide: true,
                    },
                    {
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "AdAccount", // 字段名
                        placeholder: "请输入AD账号",
                        readOnly: true,
                        requiredMessage: "未带入AD账号",
                        required: true,
                    },
                    {
                        label: "中文姓名",
                        type: "input", // 控件类型
                        field: "Name", // 字段名
                        // required: true, // 是否必填
                        requiredMessage: "请输入中文名", // 没有填写的提示
                        readOnly: true,
                        placeholder: "请输入中文名"
                    },
                    {
                        label: "英文姓名",
                        type: "input", // 控件类型
                        field: "Ename", // 字段名
                        // required: true, // 是否必填
                        requiredMessage: "请输入英文姓名", // 没有填写的提示
                        readOnly: true,
                        placeholder: "请输入英文姓名"
                    },
                    {
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "AdAccount", // 字段名
                        readOnly: true,
                        placeholder: "请输入AD账号",
                        requiredMessage: "未带入AD账号",
                        required: true,
                    },
                    {
                        label: "Email",
                        type: "input", // 控件类型
                        field: "Email", // 字段名
                        requiredMessage: "请输入Email",
                        placeholder: "请输入email",
                        rules: "email",
                        rulesMessage: "email格式不正确"
                    },
                    {
                        label: "工作部门",
                        type: "input", // 控件类型
                        field: "Depart", // 字段名
                        readOnly: true,
                        placeholder: "请输入工作部门",
                        requiredMessage: "请输入工作部门",
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        required: true,
                        requiredMessage: "请选择证件类型",
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                            default: true // 默认选中
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }],
                    },
                    {
                        label: "证件号码",
                        type: "input", // 控件类型
                        field: "IdCard", // 字段名
                        // readOnly: true,
                        required: true,
                        placeholder: "请输入证件号码",
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        idCardDateField: "Birthday",
                        cardTypeField: "CardType",
                        confirmText: confirmHtml
                    },
                    {
                        label: "证件有效截至日期",
                        type: "date", // 控件类型
                        required: true,
                        requiredMessage: "请选择证件有效截至日期",
                        field: "PaidUsedEndDate", // 字段名
                        placeholder: "请选择证件有效截至日期",
                        if: "this.form.IsForever != 'on'"
                    },
                    {
                        label: "是否长期",
                        type: "checkbox", // 控件类型
                        field: "suibian2", // 字段名
                        // labelWidth: 150,
                        if: "this.form.IsForever != 'on'",
                        option: [{
                            label: '长期',
                            field: 'IsForever'
                        }, ]
                    },
                    {
                        label: "证件有效截至日期",
                        type: "checkbox", // 控件类型
                        field: "suibian1", // 字段名
                        if: "this.form.IsForever == 'on'",
                        option: [{
                            label: '长期',
                            field: 'IsForever'
                        }, ]
                    },
                    {
                        label: "证件正面",
                        type: "upload",
                        field: "IdCardImg1",
                        ifRequired: "this.form.CardType === '身份证'",
                        //required: false,
                        requiredMessage: "请上传证件正面",
                        watermark: true
                    },
                    {
                        label: "证件反面",
                        type: "upload",
                        field: "IdCardImg2",
                        ifRequired: "this.form.CardType === '身份证'",
                        //required: false,
                        requiredMessage: "请上传证件反面",
                        watermark: true
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        required: true,
                        requiredMessage: "请选择性别",
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                                default: true // 默认选中
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ]
                    },
                    {
                        label: "出生日期",
                        type: "date", // 控件类型
                        required: true,
                        field: "Birthday", // 字段名
                        placeholder: "请选择出生日期",
                        requiredMessage: "请输入出生日期",
                    },

                    {
                        label: "入职日期",
                        type: "date", // 控件类型
                        field: "JoinDay", // 字段名
                        readOnly: true,
                        placeholder: "请选择入职日期"
                    },
                    {
                        label: "办事处",
                        type: "input", // 控件类型
                        field: "WorkUnit", // 字段名
                        readOnly: true,
                        placeholder: "请输入办事处"
                    },
                    {
                        label: "城市",
                        type: "select", // 控件类型
                        field: "City", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请选择城市", // 没有填写的提示
                        async: {
                            action: "/MobileApis/MemberHandler.ashx?action=GetCityData",
                            showField: "City"
                        },
                        // linkChange: {
                        //   "RelationType": "RelationType"
                        // }
                    },
                    {
                        label: "所属分站",
                        type: "input", // 控件类型
                        field: "Substation", // 字段名
                        readOnly: true,
                        placeholder: "请输入所属分站"
                    },
                    // {
                    //   type: "text",
                    //   text: "以上信息来自CHRIS系统，如有差错请联系HR Operation在CHRIS中直接修改，修改后数据第二天自动更新到工会网站。",
                    //   style: {
                    //     color: "#FE9A18",
                    //     'font-size': '12px'
                    //   }
                    // },

                    {
                        label: "上传头像",
                        type: "upload",
                        field: "avatarUrl",
                        required: true,
                        requiredMessage: "请上传头像"
                    },
                    {
                        label: "民族",
                        type: "select", // 控件类型
                        field: "Ethnic", // 字段名
                        placeholder: "请选择民族",
                        // option: SELECT_MAP["minzu"],
                        // required: true,
                        // requiredMessage: "请选择民族"
                    },
                    {
                        label: "学历",
                        type: "select", // 控件类型
                        field: "Education", // 字段名
                        placeholder: "请选择学历",
                        // option: SELECT_MAP["xueli"],
                        // required: true,
                        // requiredMessage: "请选择学历"
                    },
                    {
                        label: "政治面貌",
                        type: "select", // 控件类型
                        field: "PoliticsStatus", // 字段名
                        placeholder: "请选择政治面貌",
                        // option: SELECT_MAP["zhengzhimianmao"],
                        // required: true,
                        // requiredMessage: "请选择政治面貌"
                    },
                    {
                        label: "家庭住址",
                        type: "input", // 控件类型
                        field: "HomeAddr", // 字段名
                        placeholder: "请输入家庭住址",
                        // required: true,
                        // requiredMessage: "请输入家庭住址",
                    },
                    {
                        label: "邮编",
                        type: "input", // 控件类型
                        field: "PostCode", // 字段名
                        placeholder: "请输入邮编",
                    },
                    {
                        label: "联系电话",
                        type: "input", // 控件类型
                        field: "Mobile", // 字段名
                        placeholder: "请输入联系电话",
                        rules: "tel",
                        required: true, // 是否必填
                        requiredMessage: "联系电话必填", // 没有填写的提示
                        rulesMessage: "请输入正确的联系电话",
                        formatType: "tel",
                        //confirmText: confirmHtml
                    }
                ]
            }, {
                name: "fm",
                tabText: "父母及配偶父母",
                shortTitle: "父母信息",
                boxTopText: "信息内容用于活动、福利、票务、保险使用",
                boxAdd: true,
                defaultBoxNum: 0,
                column: [{
                        label: "关系",
                        type: "select",
                        field: "RelationType",

                        option: [{
                                label: '父亲',
                                value: '父亲',
                                only: true,
                                sex: "男"
                            },
                            {
                                label: '母亲',
                                value: '母亲',
                                only: true,
                                sex: "女"
                            },
                            {
                                label: '配偶父亲',
                                value: '配偶父亲',
                                only: true,
                                sex: "男"
                            },
                            {
                                label: '配偶母亲',
                                value: '配偶母亲',
                                only: true,
                                sex: "女"
                            },
                        ],
                        placeholder: "请选择",
                        required: true,
                        requiredMessage: "请选择关系",
                        linkChange: {
                            "sex": "Sex"
                        }
                    },
                    {
                        label: "姓名",
                        type: "input",
                        field: "Name",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入姓名"
                    },
                    {
                        label: "出生日期",
                        type: "date",
                        field: "Birthday",
                        placeholder: "请选择",
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        // required: true,
                        // requiredMessage: "请选择性别",
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ]
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        // required: true,
                        requiredMessage: "请选择证件类型",
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }]
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "CardNumber",
                        placeholder: "请输入",
                        // required: true,
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确格式的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        idCardDateField: "Birthday",
                        cardTypeField: "CardType",
                        confirmText: confirmHtml
                    },
                    {
                        label: "关系证明",
                        type: "upload",
                        field: "BirthIdentity",
                        max: 10,
                        // required: true,
                        requiredMessage: "请上传关系证明",
                        watermark: true,
                        tipsMessage: "请上传户口本",
                        tipsObject: {
                            RelationType: {
                                配偶父亲: "请上传结婚证及户口本",
                                配偶母亲: "请上传结婚证及户口本",
                                父亲: "请上传户口本",
                                母亲: "请上传户口本",
                            }
                        }
                    }
                ]
            },
            {
                name: "po",
                tabText: "配偶信息",
                shortTitle: "配偶信息",
                boxTopText: "信息内容用于活动、福利、票务、保险使用",
                boxAdd: true,
                defaultBoxNum: 0,
                maxBoxNum: 1,
                column: [{
                        label: "关系",
                        type: "select",
                        field: "RelationType",
                        option: [{ // 下拉数据
                            label: '配偶',
                            value: '配偶',
                            default: true // 默认选中
                        }, ],
                        hide: true,
                        placeholder: "请选择",
                        required: true,
                        requiredMessage: "请选择关系"
                    },
                    {
                        label: "姓名",
                        type: "input",
                        field: "Name",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入姓名",

                    },
                    {
                        label: "出生日期",
                        type: "date",
                        field: "Birthday",
                        placeholder: "请选择",
                        // required: true,
                        requiredMessage: "请选择出生日期"
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        readOnly: true,
                        // required: true,
                        requiredMessage: "请选择性别",
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ],
                        autoScan: "peiou"
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        // required: true,
                        requiredMessage: "请选择证件类型",
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }]
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "CardNumber",
                        placeholder: "请输入",
                        // required: true,
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确格式的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        idCardDateField: "Birthday",
                        cardTypeField: "CardType",
                        confirmText: confirmHtml
                    },
                    {
                        label: "关系证明",
                        type: "upload",
                        max: 10,
                        field: "BirthIdentity",
                        // required: true,
                        requiredMessage: "请上传关系证明",
                        watermark: true,
                        tipsMessage: "请上传结婚证"
                    }
                ]
            },
            {
                name: "zn",
                tabText: "子女信息",
                shortTitle: "子女信息",
                boxTopText: "信息内容用于六一儿童节福利、活动及相关补助",
                boxAdd: true,
                defaultBoxNum: 0,
                column: [{
                        label: "关系",
                        type: "select",
                        field: "RelationType",
                        option: [{ // 下拉数据
                            label: '子女',
                            value: '子女',
                            default: true // 默认选中
                        }, ],
                        hide: true,
                        placeholder: "请选择",
                        required: true,
                        requiredMessage: "请选择关系"
                    }, {
                        label: "姓名",
                        type: "input",
                        field: "Name",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入姓名"
                    },
                    {
                        label: "出生日期",
                        type: "date",
                        field: "Birthday",
                        placeholder: "请选择",
                        required: true,
                        requiredMessage: "请选择出生日期"
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        required: true,
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ],
                        requiredMessage: "请选择性别"
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        required: true,
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }],
                        requiredMessage: "请选择证件类型"
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "CardNumber",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确格式的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        idCardDateField: "Birthday",
                        cardTypeField: "CardType",
                        confirmText: confirmHtml
                    },
                    {
                        label: "出生证明",
                        type: "upload",
                        field: "BirthIdentity",
                        max: 10,
                        required: true,
                        requiredMessage: "请上传出生证明",
                        watermark: true
                    }
                ]
            }
        ]
    },
    积分发放表: {
        allSubmit: true,
        shortTitle: "积分发放表",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        config: [{
                name: "积分发放表（主表）", // 表单名称
                tabText: "积分发放表",
                shortTitle: "积分发放表",
                mainForm: true,
                notAuto: true,
                column: [{
                        label: "发放主题",
                        type: "input",
                        field: "GrantTitle",
                        readOnly: true,
                        col:24
                    }, {
                        label: "积分类型",
                        type: "input",
                        field: "ScoreType",
                        readOnly: true,
                    }, {
                        label: "立即发布",
                        type: "checkbox", // 控件类型
                        field: "suibian1", // 字段名
                        readOnly: true,
                        if: "this.form.ReleaseNow == 'on'",
                        option: [{
                            label: '是',
                            field: 'ReleaseNow',
                        }, ]
                    },
                    {
                        label: "预计发放时间",
                        type: "input",
                        field: "GrantDate",
                        readOnly: true,
                        if: "!this.form.ReleaseNow || this.form.ReleaseNow == 'off'"
                    }, {
                        label: "对应年份",
                        type: "input",
                        field: "DYNF",
                        readOnly: true,
                    },
                    {
                        label: "发放类型",
                        type: "input",
                        field: "Category",
                        readOnly: true,
                    }, {
                        label: "发放说明",
                        type: "textarea",
                        field: "ScoreRemark",
                        readOnly: true,
                        row: 4
                    }, {
                        label: "备注",
                        type: "textarea",
                        field: "Remark",
                        readOnly: true,
                    }, {
                        label: "发放人数",
                        type: "input",
                        field: "PersonNumber",
                        readOnly: true,
                    }, {
                        label: "总积分",
                        type: "input",
                        field: "TotalAmount",
                        readOnly: true,
                    }, {
                        label: "发放人",
                        type: "input",
                        field: "CreatorName",
                        readOnly: true,
                    }, {
                        label: "创建时间",
                        type: "input",
                        field: "CreateTime",
                        readOnly: true,
                    }
                ]
            },
            {
                name: "积分详情",
                tabText: "积分发放详情",
                // formatTabText: "[Name]",
                ismx: true,
                table: true,
                tableTree: true,
                column: [ // 指主表

                ],
                config: {
                    table: true,
                    treeTable: true,
                    slot: "jf"
                },
                detail: [{
                        label: "AD账号",
                        field: "JobNumber",
                        type: "input"
                    },
                    {
                        label: "分站名称",
                        field: "Substation",
                        type: "input"
                    },
                    {
                        label: "小组",
                        field: "GroupName",
                        type: "input"
                    },
                    {
                        label: "姓名",
                        field: "MemberName",
                        type: "input"
                    },
                    {
                        label: "英文名称",
                        field: "Ename",
                        type: "input"
                    },
                    {
                        label: "发放积分",
                        field: "Amount",
                        type: "input",
                        sum: true
                    },
                    {
                        label: "邮箱",
                        field: "Email",
                        type: "input",
                    },
                    {
                        label: "描述",
                        field: "Remark",
                        type: "input"
                    },
                    {
                        label: "发放类型",
                        field: "WelfareType",
                        type: "input",
                    },


                ]
            }
        ]
    },
    结婚慰问: {
        allSubmit: true,
        shortTitle: "福利申请表",
        config: [{
                name: "结婚慰问",
                tabText: "结婚慰问",
                action: {},
                mainForm: true,
                shortTitle: "福利申请表",
                column: [{
                        label: "申请人",
                        type: "input", // 控件类型
                        field: "MemberName", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        readOnly: true,
                    },
                    {
                        label: "入会日期",
                        type: "date", // 控件类型
                        field: "RHRQ", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        readOnly: true,
                    },
                    {
                        label: "申请人1",
                        type: "input", // 控件类型
                        field: "MemberCode", // 字段名
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        hide: true,
                        readOnly: true,
                    },
                    {
                        label: "申请福利",
                        type: "select",
                        field: "SQFL",
                        placeholder: "请输入",
                        required: true,
                        readOnly: true,
                        option: [{ // 下拉数据
                            label: '结婚慰问',
                            value: '结婚慰问',
                            default: true // 默认选中
                        }]
                    },
                    {
                        label: "申请日期",
                        type: "date", // 控件类型
                        required: true,
                        field: "CreateTime", // 字段名
                        placeholder: "请输入...",
                        autoScan: "today",
                        readOnly: true,
                    },
                    {
                        label: "结婚日期",
                        type: "date", // 控件类型
                        required: true,
                        field: "JHRQ", // 字段名
                        placeholder: "请选择...",
                        requiredMessage: "请选择结婚日期"
                    },
                    {
                        label: "证明附件",
                        type: "upload", // 控件类型
                        required: true,
                        field: "Files", // 字段名
                        placeholder: "请输入...",
                        max: 10,
                        requiredMessage: "请上传证明附件",
                        watermark: true
                    },
                    {
                        label: "备注",
                        type: "textarea", // 控件类型
                        field: "BZ", // 字段名
                        row: 4,
                        required: false, // 是否必填
                        requiredMessage: "请输入备注", // 没有填写的提示
                        placeholder: "请输入备注"
                    },
                ]
            }

        ]
    },
    生育慰问: {
        allSubmit: true,
        shortTitle: "福利申请表",
        onlyStr: "生育慰问",
        addRushTitle: "福利申请审批加催",
        button: {
            submit: { // 提交的方法
                text: "提交",
                action: "/MobileApis/DataHandler.ashx?action=SaveData",
                success: {
                    popup: "success",
                    action: "back"
                },
                // if: "this.newForm == true"
            }
        },
        status: { // 获取单子状态的方法
            action: "/MobileApis/WelfareHandler.ashx?action=GetWelfareApplyStatus",
            param: {
                type: "生育慰问"
            }
        },
        config: [{
                name: "生育慰问",
                tabText: "生育慰问",
                action: {},
                mainForm: true,
                shortTitle: "福利申请表",
                column: [{
                        label: "申请人",
                        type: "input", // 控件类型
                        field: "MemberName", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        autoScan: "user",
                        readOnly: true,
                    },
                    {
                        label: "入会日期",
                        type: "date", // 控件类型
                        field: "RHRQ", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        autoScan: "rhrq",
                        readOnly: true,
                    },
                    {
                        label: "申请人1",
                        type: "input", // 控件类型
                        field: "MemberCode", // 字段名
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        autoScan: "userCode",
                        readOnly: true,
                        hide: true,
                    },
                    {
                        label: "申请福利",
                        type: "select",
                        field: "SQFL",
                        placeholder: "请输入",
                        required: true,
                        option: [{ // 下拉数据
                            label: '生育慰问',
                            value: '生育慰问',
                            default: true // 默认选中
                        }],
                        readOnly: true
                    },
                    {
                        label: "申请日期",
                        type: "date", // 控件类型
                        required: true,
                        field: "CreateTime", // 字段名
                        placeholder: "请选择...",
                        autoScan: "today",
                        readOnly: true
                    },
                    {
                        label: "子女姓名",
                        type: "input", // 控件类型
                        required: true,
                        field: "ChildName", // 字段名
                        requiredMessage: "请输入子女姓名",
                        placeholder: "请输入...",
                    },
                    {
                        label: "子女性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择...",
                        required: true,
                        requiredMessage: "请选择子女性别",
                        option: [{ // 下拉数据
                            label: '男',
                            value: '男',
                            default: true // 默认选中
                        }, { // 下拉数据
                            label: '女',
                            value: '女'
                        }]
                    },
                    {
                        label: "出生日期",
                        type: "date", // 控件类型
                        required: true,
                        field: "Birth", // 字段名
                        placeholder: "请输入...",
                        requiredMessage: "请选择出生日期",
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        required: true,
                        requiredMessage: "请选择证件类型",
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                            default: true // 默认选中
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }]
                    },
                    {
                        label: "证件号",
                        type: "input", // 控件类型
                        required: true,
                        field: "IDCard", // 字段名
                        placeholder: "请输入...",
                        requiredMessage: "请输入证件号",
                        rules: "idCard",
                        rulesMessage: "请输入正确的身份证",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        idCardDateField: "Birth",
                        cardTypeField: "CardType"
                    },
                    {
                        label: "出生证明",
                        type: "upload", // 控件类型
                        required: true,
                        max: 10,
                        field: "Files", // 字段名
                        placeholder: "请选择...",
                        requiredMessage: "请上传出生证明",
                        watermark: true
                    },

                    {
                        label: "备注",
                        type: "textarea", // 控件类型
                        field: "BZ", // 字段名
                        row: 4,
                        required: false, // 是否必填
                        requiredMessage: "请输入...", // 没有填写的提示
                        placeholder: "请输入"
                    },
                ]
            }

        ]
    },
    会员信息: {
        allSubmit: true,
        shortTitle: "会员信息修改审批单",
        slot: "会员信息",
        addRushTitle: "会员修改审批加催",
        button: {
            submit: { // 提交的方法
                text: "提交修改",
                action: "/MobileApis/MemberChangeHandler.ashx?action=AddMemberChange",
                success: {
                    popup: "success",
                    action: "reload"
                },
                dataId: true,
                if: "this.newForm == true"
            }
        },
        getOldDataAction: { // 获取原来单子的方法
            action: "/MobileApis/MemberChangeHandler.ashx?action=GetMemberChange"
        },
        status: { // 获取单子状态的方法
            action: "/MobileApis/MemberChangeHandler.ashx?action=GetMemberChangeStatus",
        },
        edit: {
            action: "/MobileApis/MemberChangeHandler.ashx?action=AddMemberChange",
        },
        getAutoDataAction: { // 新单子时获取自动获取数据的方法
            action: "/MobileApis/MemberHandler.ashx?action=GetMemberInfo",
            param: {
                shortTitle: "人员信息表",
                type: "123"
            }

        },
        selfSpdingMessage: "信息审批中，请等待流程完毕",
        config: [{
                name: "jbxx", // 表单名称
                tabText: "会员信息",
                shortTitle: "会员信息表",
                mainForm: true,
                action: { // 接口交互
                    new: { // new接口
                        url: "/newform"
                    },
                    edit: { // edit接口
                        url: "/editForm"
                    }
                },
                column: [{
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "Code", // 字段名
                        // required: true, // 是否必填
                        requiredMessage: "未代入AD账号",
                        placeholder: "请输入AD账号",
                        readOnly: true,
                        // placeholder: "请输入AD账号",
                        // readOnly: true,
                        hide: true,
                    },
                    {
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "AdAccount", // 字段名
                        placeholder: "请输入AD账号",
                        readOnly: true,
                        requiredMessage: "未带入AD账号",
                        required: true,
                    },
                    {
                        label: "中文姓名",
                        type: "input", // 控件类型
                        field: "Name", // 字段名
                        // required: true, // 是否必填
                        requiredMessage: "请输入中文名", // 没有填写的提示
                        placeholder: "请输入中文名",
                        readOnly: true
                    },
                    {
                        label: "英文姓名",
                        type: "input", // 控件类型
                        field: "Ename", // 字段名
                        // required: true, // 是否必填
                        requiredMessage: "请输入英文姓名", // 没有填写的提示
                        placeholder: "请输入英文姓名",
                        readOnly: true
                    },

                    {
                        label: "Email",
                        type: "input", // 控件类型
                        field: "Email", // 字段名
                        placeholder: "请输入email",
                    },
                    {
                        label: "工作部门",
                        type: "input", // 控件类型
                        field: "Depart", // 字段名
                        placeholder: "请输入工作部门",
                        readOnly: true
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        required: true,
                        requiredMessage: "请选择证件类型",
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                            default: true // 默认选中
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }],
                    },
                    {
                        label: "证件号码",
                        type: "input", // 控件类型
                        field: "IdCard", // 字段名
                        required: true,
                        placeholder: "请输入证件号码",
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        linkChangeCacheIf: "this.form.CardType == '身份证'",
                        linkChangeCache: {
                            "IdCardImg1": "",
                            "IdCardImg2": "",
                        },
                        linkChangeMessage: "因证件号码变动，请重新上传证件照",
                        idCardDateField: "Birthday",
                        cardTypeField: "CardType",
                        confirmText: confirmHtml
                    },
                    {
                        label: "证件有效截至日期",
                        type: "date", // 控件类型
                        required: true,
                        requiredMessage: "请选择证件有效截至日期",
                        field: "PaidUsedEndDate", // 字段名
                        placeholder: "请选择证件有效截至日期",
                        if: "this.form.IsForever != 'on'"
                    },
                    {
                        label: "是否长期",
                        type: "checkbox", // 控件类型
                        field: "suibian2", // 字段名
                        // labelWidth: 150,
                        if: "this.form.IsForever != 'on'",
                        option: [{
                            label: '长期',
                            field: 'IsForever'
                        }, ]
                    },
                    {
                        label: "证件有效截至日期",
                        type: "checkbox", // 控件类型
                        field: "suibian1", // 字段名
                        if: "this.form.IsForever == 'on'",
                        option: [{
                            label: '长期',
                            field: 'IsForever'
                        }, ]
                    },
                    {
                        label: "证件正面",
                        type: "upload",
                        field: "IdCardImg1",
                        //required: true,
                        requiredMessage: "请上传证件正面",
                        watermark: true,
                        ifRequired: "this.form.CardType === '身份证'",
                    },
                    {
                        label: "证件反面",
                        type: "upload",
                        field: "IdCardImg2",
                        //required: true,
                        requiredMessage: "请上传证件反面",
                        watermark: true,
                        ifRequired: "this.form.CardType === '身份证'",
                    },
                    {
                        label: "上传头像",
                        type: "upload",
                        field: "avatarUrl",
                        required: true,
                        requiredMessage: "请上传头像"
                    },
                    {
                        label: "出生日期",
                        type: "date", // 控件类型
                        required: true,
                        requiredMessage: "请选择出生日期",
                        field: "Birthday", // 字段名
                        placeholder: "请选择出生日期",
                    },
                    {
                        label: "入职日期",
                        type: "date", // 控件类型
                        field: "JoinDay", // 字段名
                        placeholder: "请选择入职日期",
                        readOnly: true
                    },
                    {
                        label: "入会日期",
                        type: "date", // 控件类型
                        field: "JoinMemberDay", // 字段名
                        placeholder: "请选择入会日期",
                        readOnly: true
                    },
                    {
                        label: "办事处",
                        type: "input", // 控件类型
                        field: "WorkUnit", // 字段名
                        placeholder: "请输入办事处",
                        readOnly: true
                    },
                    {
                        label: "城市",
                        type: "select", // 控件类型
                        slot: "city",
                        field: "City", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请选择城市", // 没有填写的提示
                        async: {
                            // action: "/MobileApis/MemberHandler.ashx?action=GetCityData",
                            action: "/MobileApis/MemberHandler.ashx?action=GetCityData1",
                            showField: "City"
                        },
                        // linkChange: {
                        //   "RelationType": "RelationType"
                        // }
                    },
                    {
                        label: "所属分站",
                        type: "input", // 控件类型
                        field: "Substation", // 字段名
                        placeholder: "请输入所属分站",
                        readOnly: true
                    },
                    {
                        label: "所属小组",
                        type: "input", // 控件类型
                        field: "GroupName", // 字段名
                        readOnly: true,
                        placeholder: " "
                    },
                    {
                        label: "小组长信息",
                        type: "info", // 控件类型
                        field: "zxzxx", // 字段名
                        placeholder: "点击查看小组长信息",
                        readOnly: true,
                        action: "/MobileApis/AppUserHandler.ashx?action=GetGroupManager",
                        slot: "groupBoss"
                    },
                    // {
                    //   type: "text",
                    //   text: "以上信息来自CHRIS系统，如有差错请联系HR Operation在CHRIS中直接修改，修改后数据第二天自动更新到工会网站。",
                    //   style: {
                    //     color: "#FE9A18",
                    //     'font-size': '12px'
                    //   }
                    // },
                    {
                        label: "民族",
                        type: "select", // 控件类型
                        field: "Ethnic", // 字段名
                        placeholder: "请选择民族",
                        // option: SELECT_MAP["minzu"],
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        required: true,
                        requiredMessage: "请选择性别",
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                                default: true // 默认选中
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ]
                    },
                    {
                        label: "学历",
                        type: "select", // 控件类型
                        field: "Education", // 字段名
                        placeholder: "请选择学历",
                        // option: SELECT_MAP["xueli"],
                    },
                    {
                        label: "政治面貌",
                        type: "select", // 控件类型
                        field: "PoliticsStatus", // 字段名
                        placeholder: "请选择政治面貌",
                        // option: SELECT_MAP["zhengzhimianmao"],
                    },
                    {
                        label: "家庭住址",
                        type: "input", // 控件类型
                        field: "HomeAddr", // 字段名
                        placeholder: "请输入家庭住址",
                    },
                    {
                        label: "邮编",
                        type: "input", // 控件类型
                        field: "PostCode", // 字段名
                        placeholder: "请输入邮编",
                    },
                    {
                        label: "联系电话",
                        type: "input", // 控件类型
                        field: "Mobile", // 字段名
                        placeholder: "请输入联系电话",
                        rules: "tel",
                        required: true, // 是否必填
                        requiredMessage: "联系电话必填", // 没有填写的提示
                        rulesMessage: "请输入正确的联系电话",
                        // exButton: {
                        //   action: "/MobileApis/MemberChangeHandler.ashx?action=UpdateMemberInfo",
                        //   text: "修改手机",
                        //   param: {
                        //     mobile: "[Mobile]"
                        //   },
                        //   rules: {
                        //     type: "tel",
                        //     field: "mobile",
                        //     message: "联系电话格式不正确"
                        //   }
                        // },
                        formatType: "tel",
                        //confirmText: confirmHtml
                    }
                ]
            }, {
                name: "fm",
                tabText: "父母及配偶父母",
                shortTitle: "父母信息",
                boxTopText: "信息内容用于活动、福利、票务、保险使用",
                boxAdd: true,
                column: [{
                        label: "关系",
                        type: "select",
                        field: "RelationType",
                        option: [{
                                label: '父亲',
                                value: '父亲',
                                only: true,
                                sex: "男"
                            },
                            {
                                label: '母亲',
                                value: '母亲',
                                only: true,
                                sex: "女"
                            },
                            {
                                label: '配偶父亲',
                                value: '配偶父亲',
                                only: true,
                                sex: "男"
                            },
                            {
                                label: '配偶母亲',
                                value: '配偶母亲',
                                only: true,
                                sex: "女"
                            },
                        ],
                        placeholder: "请选择",
                        required: true,
                        requiredMessage: "请选择关系",
                        linkChange: {
                            "sex": "Sex"
                        }
                    },
                    {
                        label: "姓名",
                        type: "input",
                        field: "Name",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入姓名"
                    },
                    {
                        label: "出生日期",
                        type: "date",
                        field: "Birthday",
                        placeholder: "请选择",
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        // required: true,
                        // requiredMessage: "请选择性别",
                        readOnly: true,
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ]
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }]
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "CardNumber",
                        placeholder: "请输入",
                        // required: true,
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确格式的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        idCardDateField: "Birthday",
                        cardTypeField: "CardType",
                        confirmText: confirmHtml
                    },
                    {
                        label: "关系证明",
                        type: "upload",
                        field: "BirthIdentity",
                        max: 10,
                        // required: true,
                        requiredMessage: "请上传关系证明",
                        watermark: true,
                        tipsMessage: "请上传户口本",
                        tipsObject: {
                            RelationType: {
                                配偶父亲: "请上传结婚证及户口本",
                                配偶母亲: "请上传结婚证及户口本",
                                父亲: "请上传户口本",
                                母亲: "请上传户口本",
                            }
                        }
                    }
                ]
            },
            {
                name: "po",
                tabText: "配偶信息",
                shortTitle: "配偶信息",
                boxTopText: "信息内容用于活动、福利、票务、保险使用",
                boxAdd: true,
                maxBoxNum: 1,
                column: [{
                        label: "关系",
                        type: "select",
                        field: "RelationType",
                        option: [{ // 下拉数据
                            label: '配偶',
                            value: '配偶',
                            default: true // 默认选中
                        }, ],
                        hide: true,
                        placeholder: "请选择",
                        required: true
                    },
                    {
                        label: "姓名",
                        type: "input",
                        field: "Name",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入姓名"
                    },
                    {
                        label: "出生日期",
                        type: "date",
                        field: "Birthday",
                        placeholder: "请选择",
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        // required: true,
                        requiredMessage: "请选择性别",
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ],
                        autoScan: "peiou",
                        readOnly: true
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        // required: true,
                        requiredMessage: "请选择证件类型",
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, { // 下拉数据
                            label: '其他',
                            value: '其他',
                        }]
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "CardNumber",
                        placeholder: "请输入",
                        // required: true,
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确格式的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        confirmText: confirmHtml
                    },
                    {
                        label: "关系证明",
                        type: "upload",
                        field: "BirthIdentity",
                        max: 10,
                        // required: true,
                        requiredMessage: "请上传关系证明",
                        watermark: true,
                        tipsMessage: "请上传结婚证"
                    }
                ]
            },
            {
                name: "zn",
                tabText: "子女信息",
                shortTitle: "子女信息",
                boxTopText: "信息内容用于六一儿童节福利、活动及相关补助",
                boxAdd: true,
                column: [{
                        label: "关系",
                        type: "select",
                        field: "RelationType",
                        option: [{ // 下拉数据
                            label: '子女',
                            value: '子女',
                            default: true // 默认选中
                        }, ],
                        hide: true,
                        placeholder: "请选择",
                        required: true
                    }, {
                        label: "姓名",
                        type: "input",
                        field: "Name",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入姓名"
                    },
                    {
                        label: "出生日期",
                        type: "date",
                        field: "Birthday",
                        placeholder: "请选择",
                        required: true,
                        requiredMessage: "请选择出生日期"
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "Sex",
                        placeholder: "请选择性别",
                        required: true,
                        option: [{ // 下拉数据
                                label: '男',
                                value: '男',
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ],
                        requiredMessage: "请选择性别"
                    },
                    {
                        label: "证件类型",
                        type: "select",
                        field: "CardType",
                        required: true,
                        option: [{ // 下拉数据
                            label: '身份证',
                            value: '身份证',
                        }, { // 下拉数据
                            label: '护照',
                            value: '护照',
                        }, {
                            label: '其他',
                            value: '其他',
                        }],
                        requiredMessage: "请选择证件类型"
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "CardNumber",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入证件号码",
                        rules: "idCard",
                        rulesMessage: "请输入正确格式的证件号码",
                        ifRules: "this.form.CardType != '护照' && this.form.CardType != '其他'",
                        formatType: "idCard",
                        idCardDateField: "Birthday",
                        cardTypeField: "CardType",
                        confirmText: confirmHtml
                    },
                    {
                        label: "出生证明",
                        type: "upload",
                        field: "BirthIdentity",
                        max: 10,
                        required: true,
                        requiredMessage: "请上传出生证明",
                        watermark: true
                    }
                ]
            }
        ]
    },
    工会信息: {
        allSubmit: true,
        shortTitle: "工会信息",
        config: [{
                name: "工会信息",
                tabText: "工会信息",
                action: {},
                mainForm: true,
                shortTitle: "工会信息",
                column: [{
                        label: "标题",
                        type: "input", // 控件类型
                        field: "Title", // 字段名
                        readOnly: true
                    },
                    {
                        label: "信息类型",
                        type: "input", // 控件类型
                        field: "Type", // 字段名
                        readOnly: true
                    }, {
                        label: "置顶",
                        type: "select", // 控件类型
                        field: "IsTop", // 字段名
                        readOnly: true,
                        option: [{
                            label: "不置顶",
                            value: 0
                        }, {
                            label: '普通置顶',
                            value: 1
                        }, {
                            label: '强制置顶',
                            value: 2
                        }]
                    },
                    {
                        label: "发送通知",
                        type: "select", // 控件类型
                        field: "SendNotice", // 字段名
                        readOnly: true,
                        option: [{
                            label: '否',
                            value: 'off'
                        }, {
                            label: '是',
                            value: 'on'
                        }]
                    },
                    {
                        label: "立即发布",
                        type: "checkbox", // 控件类型
                        field: "suibian1", // 字段名
                        readOnly: true,
                        if: "this.form.ReleaseNow == 'on'",
                        option: [{
                            label: '是',
                            field: 'ReleaseNow'
                        }, ]
                    },
                    {
                        label: "定时发布",
                        type: "input", // 控件类型
                        field: "QuartzTime", // 字段名
                        readOnly: true
                    }, {
                        label: "实际发布时间",
                        type: "input", // 控件类型
                        field: "ReleaseTime", // 字段名
                        readOnly: true
                    },
                    {
                        label: "信息编辑",
                        type: "richText", // 控件类型
                        field: "Content", // 字段名
                        readOnly: true,
                    },
                    // {
                    //   label: "选择人员",
                    //   type: "input", // 控件类型
                    //   field: "ReceiverNames", // 字段名
                    //   readOnly: true
                    // },

                    {
                        label: "封面图片",
                        type: "upload", // 控件类型
                        field: "CoverImg", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "摘要",
                        type: "input", // 控件类型
                        field: "Abstract", // 字段名
                        readOnly: true
                    },
                    {
                        label: "是否评论",
                        type: "input", // 控件类型
                        field: "IsCommentAllow", // 字段名
                        readOnly: true
                    },
                    {
                        label: "是否点赞",
                        type: "input", // 控件类型
                        field: "IsDianZanAllow", // 字段名
                        readOnly: true
                    },
                    {
                        label: "内容类型",
                        type: "input", // 控件类型
                        field: "ContentType", // 字段名
                        readOnly: true
                    },
                    {
                        label: "发布人",
                        type: "input", // 控件类型
                        field: "CreateUserName", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "创建时间",
                        type: "input", // 控件类型
                        field: "CreateTime", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "通知分站",
                        type: "input", // 控件类型
                        field: "StationName", // 字段名
                        readOnly: true,
                        if: "this.form.SendNotice == 'on'",
                        col:24,
                    }
                ]
            }

        ]
    },
    主席信箱_我要提问: {
        allSubmit: true,
        shortTitle: "主席信箱_我要提问",
        config: [{
                name: "回复",
                tabText: "回复",
                action: {},
                mainForm: true,
                shortTitle: "主席信箱_我要提问",
                column: [{
                        label: "主题",
                        type: "input", // 控件类型
                        field: "Title", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "发送人",
                        type: "input", // 控件类型
                        field: "CreateUserName", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "所属分站",
                        type: "input", // 控件类型
                        field: "StationName", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "所属办事处",
                        type: "input", // 控件类型
                        field: "WorkUnit", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "联系电话",
                        type: "input", // 控件类型
                        field: "Mobile", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "上级经理AD",
                        type: "input", // 控件类型
                        field: "ManagerAdAccount", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "上级经理中文名",
                        type: "input", // 控件类型
                        field: "ManagerName", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "上级经理英文名",
                        type: "input", // 控件类型
                        field: "ManagerEname", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "邮箱",
                        type: "input",
                        field: "Email",
                        placeholder: "请输入",
                        required: true,
                        requiredMessage: "请输入邮箱",
                        rules: "email",
                        rulesMessage: "请输入正确的邮箱",
                        readOnly: true,
                        autoScan: "userEmail"
                    },
                    {
                        label: "内容",
                        type: "textarea", // 控件类型
                        required: true,
                        field: "Content", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "是否公开提问",
                        type: "select",
                        field: "IsOpen",
                        option: [{ // 下拉数据
                            label: '否',
                            value: 0,
                            default: true // 默认选中
                        }, { // 下拉数据
                            label: '是',
                            value: 1,
                        }],
                    }
                ]

            }

        ]
    },
    专项礼品: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "专项礼品（主表）", // 表单名称
                tabText: "专项礼品（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: [...GENERAL_ACTIVE_MAIN_CONFIG_COLUMN.filter((item) => item.label != "报名开始时间" && item.label != "报名结束时间"), {
                    label: "报名选择限制-最少",
                    type: "input",
                    field: "MinLimit",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "报名选择限制-最多",
                    type: "input",
                    field: "MaxLimit",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "咨询电话",
                    type: "input",
                    field: "ConsultationPhone",
                    readOnly: true,
                }]
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [],
                detail: [{
                        label: "图片",
                        field: "DesImage",
                        type: "upload"
                    },
                    {
                        label: "说明",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "数量上限",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "单人最多数量",
                        field: "SignUpLimit",
                        type: "input"
                    }
                ]
            }
        ]
    },
    统一积分发放表: {
        allSubmit: true,
        shortTitle: "统一积分发放表",
        isActive: true,
        generalAction: true,
        okNeedIdea: false,
        config: [{
                name: "统一积分发放表（主表）", // 表单名称
                tabText: "统一积分发放表",
                shortTitle: "统一积分发放表",
                mainForm: true,
                notAuto: true,
                column: [{
                        label: "福利名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "福利类型",
                        type: "input",
                        field: "WTypeName",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "立即发布",
                        type: "checkbox", // 控件类型
                        field: "suibian1", // 字段名
                        readOnly: true,
                        if: "this.form.ReleaseNow == 'on'",
                        labelWidth: 150,
                        option: [{
                            label: '是',
                            field: 'ReleaseNow'
                        }, ]
                    },
                    {
                        label: "发放日期",
                        type: "input",
                        field: "GrantDate",
                        readOnly: true,
                        labelWidth: 150,
                        if: "!this.form.ReleaseNow || this.form.ReleaseNow == 'off'"
                    },
                    {
                        label: "福利对应年份",
                        type: "input",
                        field: "FLDYNF",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "发放金额",
                        type: "input",
                        field: "FFJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "总人数",
                        type: "input",
                        field: "ZRS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "总份数",
                        type: "input",
                        field: "ZFS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "汇总金额",
                        type: "input",
                        field: "HZJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "实际汇总金额",
                        type: "input",
                        field: "SJHZJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "发放形式",
                        type: "input",
                        field: "FFXS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "电子卡模板名称",
                        type: "input",
                        field: "ECardTemplateName",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "是否POP窗提醒",
                        type: "select",
                        field: "RemindStatus",
                        readOnly: true,
                        labelWidth: 150,
                        option: [{
                            label: "不提醒",
                            value: 0
                        }, {
                            label: '提醒',
                            value: 1
                        }]
                    },
                    {
                        label: "消息模板",
                        type: "input",
                        field: "MessageTemplateName",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "入会时间设置",
                        type: "input",
                        field: "JoinMemberDate",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "POP窗图片",
                        type: "upload",
                        field: "PopImage",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "发放备注",
                        type: "input",
                        field: "FFNR",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "通知内容",
                        type: "richText",
                        field: "TZNR",
                        readOnly: true,
                    }, {
                        label: "创建时间",
                        type: "input",
                        field: "CreateTime",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "创建人",
                        type: "input",
                        field: "CreateUserName",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "创建人账号",
                        type: "input",
                        field: "CreateUserId",
                        readOnly: true,
                        labelWidth: 150
                    }
                ]
            },
            {
                name: "统一积分发放表（明细表）",
                tabText: "福利发放人员",
                // formatTabText: "[Name]",
                config: {
                    table: true,
                    treeTable: true,
                    slot: "jf"
                },
                ismx: true,
                column: [ // 指主表

                ],
                detail: [{
                        label: "分站名称",
                        field: "Substation",
                        type: "input"
                    },
                    {
                        label: "小组",
                        field: "GroupName",
                        type: "input"
                    },
                    {
                        label: "AD账号",
                        field: "JobNumber",
                        type: "input"
                    },
                    {
                        label: "姓名",
                        field: "MemberName",
                        type: "input"
                    },
                    {
                        label: "英文名称",
                        field: "Ename",
                        type: "input"
                    },
                    {
                        label: "出生日期",
                        field: "Birthday",
                        type: "input"
                    },
                    {
                        label: "入会日期",
                        field: "JoinMemberDay",
                        type: "input"
                    },
                    {
                        label: "发放金额",
                        field: "Amount",
                        type: "input",
                        sum: true
                    },
                    {
                        label: "数量",
                        field: "Num",
                        type: "input"
                    },
                    {
                        label: "性别",
                        field: "Sex",
                        if: "this.mainData.WTypeName == '妇女节慰问'"
                    },
                    {
                        label: "子女数量",
                        field: "ChildCount",
                        if: "this.mainData.WTypeName == '儿童节慰问'"
                    }
                ]
            }
        ]
    },

    主席积分发放: {
        allSubmit: true,
        shortTitle: "主席积分发放",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        config: [{
                name: "主席积分发放（主表）", // 表单名称
                tabText: "主席积分发放（主表）",
                shortTitle: "主席积分发放",
                mainForm: true,
                notAuto: true,
                column: [{
                        label: "发放主题",
                        type: "input",
                        field: "GrantTitle2",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "积分类型",
                        type: "input",
                        field: "ScoreType",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "发放时间",
                        type: "input",
                        field: "GrantDate",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "对应年份",
                        type: "input",
                        field: "DYNF",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "积分备注",
                        type: "input",
                        field: "ScoreRemark",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "发放备注",
                        type: "input",
                        field: "Remark",
                        readOnly: true,
                        labelWidth: 150
                    },
                    // {
                    //     label: "每人发放积分",
                    //     type: "input",
                    //     field: "Amount",
                    //     readOnly: true,
                    //     labelWidth: 150
                    // }, 
                    {
                        label: "发放人数",
                        type: "input",
                        field: "PersonNumber",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "总积分",
                        type: "input",
                        field: "TotalAmount",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "发放人",
                        type: "input",
                        field: "CreatorName",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "创建时间",
                        type: "input",
                        field: "CreateTime",
                        readOnly: true,
                        labelWidth: 150
                    }
                ]
            },
            {
                name: "明细表",
                tabText: "明细表",
                // formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表

                ],
                config: {
                    table: true,
                    treeTable: true,
                    slot: "jf"
                },
                detail: [{
                        label: "AD账号",
                        field: "JobNumber",
                        type: "input"
                    },
                    {
                        label: "分站名称",
                        field: "Substation",
                        type: "input"
                    },
                    {
                        label: "小组",
                        field: "GroupName",
                        type: "input"
                    },
                    {
                        label: "姓名",
                        field: "MemberName",
                        type: "input"
                    },
                    {
                        label: "英文名称",
                        field: "Ename",
                        type: "input"
                    },
                    {
                        label: "发放积分",
                        field: "Amount",
                        type: "input",
                        sum: true
                    },
                    {
                        label: "邮箱",
                        field: "Email",
                        type: "input",
                    },
                    {
                        label: "描述",
                        field: "Remark",
                        type: "input"
                    },
                    {
                        label: "发放类型",
                        field: "WelfareType",
                        type: "input",
                    },


                ]
            }
        ]
    },

    积分调整: {
        allSubmit: true,
        shortTitle: "积分备注",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        title: "积分调整审批",
        config: [{
            name: "积分调整（主表）", // 表单名称
            tabText: "积分调整（主表）",
            shortTitle: "积分备注",
            mainForm: true,
            notAuto: true,
            column: [{
                    label: "AD账号",
                    type: "input",
                    field: "JobNumber",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "姓名",
                    type: "input",
                    field: "MemberName",
                    readOnly: true,
                    labelWidth: 150
                },
                {
                    label: "英文名",
                    type: "input",
                    field: "Ename",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "分站",
                    type: "input",
                    field: "Substation",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "小组",
                    type: "input",
                    field: "GroupName",
                    readOnly: true,
                    labelWidth: 150
                },
                {
                    label: "调整模式",
                    type: "input",
                    field: "ChangeMethod",
                    readOnly: true,
                    labelWidth: 150
                },
                {
                    label: "目前剩余积分",
                    type: "input",
                    field: "Balance",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "预计调整积分",
                    type: "input",
                    field: "Amount",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "预计调整后余额",
                    type: "input",
                    field: "EstimatedAdjustedBalance",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "实际调整积分",
                    type: "input",
                    field: "ActAmount",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "积分差额",
                    type: "input",
                    field: "VariationPointsDifference",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "备注类型",
                    type: "input",
                    field: "RemarkType",
                    readOnly: true,
                    labelWidth: 150
                },
                {
                    type: "text",
                    text: "说明：预计调整积分请输入正数，若调整模式为积分调减，则表示扣减会员相应积分.",
                    style: {
                        color: "#FE9A18",
                        'font-size': '12px'
                    }
                }, {
                    label: "备注内容",
                    type: "textarea",
                    field: "RemarkContent",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "附件",
                    type: "upload",
                    field: "Files",
                    readOnly: true,
                    labelWidth: 150
                }
            ]
        }]
    },

    线下福利发放表: {
        allSubmit: true,
        shortTitle: "线下福利发放表",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        config: [{
                name: "线下福利发放表（主表）", // 表单名称
                tabText: "线下福利发放表（主表）",
                shortTitle: "线下福利发放表",
                mainForm: true,
                notAuto: true,
                column: [{
                        label: "福利名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "福利类型",
                        type: "input",
                        field: "WTypeName",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "立即发布",
                        type: "checkbox", // 控件类型
                        field: "suibian1", // 字段名
                        readOnly: true,
                        if: "this.form.ReleaseNow == 'on'",
                        labelWidth: 150,
                        option: [{
                            label: '是',
                            field: 'ReleaseNow'
                        }, ]
                    },
                    {
                        label: "发放日期",
                        type: "input",
                        field: "GrantDate",
                        readOnly: true,
                        labelWidth: 150,
                        if: "!this.form.ReleaseNow || this.form.ReleaseNow == 'off'"
                    },
                    {
                        label: "福利对应年份",
                        type: "input",
                        field: "FLDYNF",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "发放金额",
                        type: "input",
                        field: "FFJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "总人数",
                        type: "input",
                        field: "ZRS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "总份数",
                        type: "input",
                        field: "ZFS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "汇总金额",
                        type: "input",
                        field: "HZJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "实际汇总金额",
                        type: "input",
                        field: "SJHZJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "发放形式",
                        type: "input",
                        field: "FFXS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "电子卡模板名称",
                        type: "input",
                        field: "ECardTemplateName",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "是否POP窗提醒",
                        type: "select",
                        field: "RemindStatus",
                        readOnly: true,
                        labelWidth: 150,
                        option: [{
                            label: "不提醒",
                            value: 0
                        }, {
                            label: '提醒',
                            value: 1
                        }]
                    }, {
                        label: "消息模板",
                        type: "input",
                        field: "MessageTemplateName",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "POP窗图片",
                        type: "upload",
                        field: "PopImage",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "发放备注",
                        type: "input",
                        field: "FFNR",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "通知内容",
                        type: "richText",
                        field: "TZNR",
                        readOnly: true,
                    }, {
                        label: "创建时间",
                        type: "input",
                        field: "CreateTime",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "创建人",
                        type: "input",
                        field: "CreateUserName",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "创建人账号",
                        type: "input",
                        field: "CreateUserId",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "入会时间设置",
                        type: "input",
                        field: "JoinMemberDate",
                        readOnly: true,
                        labelWidth: 150
                    },
                ]
            },
            {
                name: "线下福利发放表（明细表）",
                tabText: "线下福利发放表（明细表）",
                // formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表

                ],
                detail: [{
                        label: "分站名称",
                        field: "Substation",
                        type: "input"
                    },
                    {
                        label: "小组",
                        field: "GroupName",
                        type: "input"
                    },
                    {
                        label: "AD账号",
                        field: "JobNumber",
                        type: "input"
                    },
                    {
                        label: "姓名",
                        field: "MemberName",
                        type: "input"
                    },
                    {
                        label: "英文名称",
                        field: "Ename",
                        type: "input"
                    },
                    {
                        label: "发放积分",
                        field: "Amount",
                        type: "input"
                    },
                    {
                        label: "数量",
                        field: "Num",
                        type: "input"
                    }
                ]
            }
        ]
    },

    员工慰问单: {
        allSubmit: true,
        shortTitle: "员工慰问单",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        config: [{
            name: "员工慰问（主表）", // 表单名称
            tabText: "员工慰问（主表）",
            shortTitle: "员工慰问单",
            mainForm: true,
            notAuto: true,
            column: [{
                    label: "姓名",
                    type: "input",
                    field: "MemberName",
                    readOnly: true,
                },
                {
                    label: "AD账号",
                    type: "input",
                    field: "MemberCode",
                    readOnly: true
                },
                {
                    label: "慰问类型",
                    type: "input",
                    field: "fillInType",
                    readOnly: true,
                }, {
                    label: "填单时间",
                    type: "input",
                    field: "fillInDate",
                    readOnly: true,
                }, {
                    label: "填单人",
                    type: "input",
                    field: "UserName",
                    readOnly: true
                }, {
                    label: "事项说明",
                    type: "input",
                    field: "Remark",
                    readOnly: true,
                }, {
                    label: "图片资料",
                    type: "upload",
                    field: "FaceImage",
                    readOnly: true
                }
            ]
        }]
    },

    员工直系亲属丧事慰问单: {
        allSubmit: true,
        shortTitle: "员工慰问单",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        title: "直系亲属丧事慰问单",
        config: [{
            name: "直系亲属丧事慰问单（主表）", // 表单名称
            tabText: "直系亲属丧事慰问单",
            shortTitle: "员工慰问单",
            mainForm: true,
            notAuto: true,
            column: [{
                    label: "姓名",
                    type: "input",
                    field: "MemberName",
                    readOnly: true,
                },
                {
                    label: "AD账号",
                    type: "input",
                    field: "MemberCode",
                    readOnly: true
                },
                {
                    label: "慰问类型",
                    type: "input",
                    field: "fillInType",
                    readOnly: true,
                }, {
                    label: "填单时间",
                    type: "input",
                    field: "fillInDate",
                    readOnly: true,
                }, {
                    label: "填单人",
                    type: "input",
                    field: "UserName",
                    readOnly: true
                }, {
                    label: "事项说明",
                    type: "textarea",
                    field: "Remark",
                    readOnly: true,
                }, {
                    label: "图片资料",
                    type: "upload",
                    field: "FaceImage",
                    readOnly: true
                }
            ]
        }]
    },

    员工病假慰问单: {
        allSubmit: true,
        shortTitle: "员工慰问单",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        title: "病假慰问",
        config: [{
            name: "病假慰问（主表）", // 表单名称
            tabText: "病假慰问",
            shortTitle: "员工慰问单",
            mainForm: true,
            notAuto: true,
            column: [{
                    label: "姓名",
                    type: "input",
                    field: "MemberName",
                    readOnly: true,
                },
                {
                    label: "AD账号",
                    type: "input",
                    field: "MemberCode",
                    readOnly: true
                },
                {
                    label: "慰问类型",
                    type: "input",
                    field: "fillInType",
                    readOnly: true,
                }, {
                    label: "填单时间",
                    type: "input",
                    field: "fillInDate",
                    readOnly: true,
                }, {
                    label: "填单人",
                    type: "input",
                    field: "UserName",
                    readOnly: true
                }, {
                    label: "事项说明",
                    type: "textarea",
                    field: "Remark",
                    readOnly: true,
                }, {
                    label: "图片资料",
                    type: "upload",
                    field: "FaceImage",
                    readOnly: true
                }
            ]
        }]
    },

    季度费用申请: {
        allSubmit: true,
        shortTitle: "季度费用申请",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        titile: "季度费用申请单",
        config: [{
                name: "季度费用申请单（主表）", // 表单名称
                tabText: "季度费用申请单（主表）",
                shortTitle: "季度费用申请",
                mainForm: true,
                notAuto: true,
                column: [{
                        label: "费用年度",
                        type: "input",
                        field: "YSND",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "费用季度",
                        type: "select",
                        field: "YSJD",
                        labelWidth: 150,
                        option: [{ // 下拉数据
                            label: '第一季度',
                            value: '1',
                            default: true // 默认选中
                        }, { // 下拉数据
                            label: '第二季度',
                            value: '2',
                        }, { // 下拉数据
                            label: '第三季度',
                            value: '3',
                        }, { // 下拉数据
                            label: '第四季度',
                            value: '4',
                        }],
                    },
                    {
                        label: "人均金额（元/人/月）",
                        type: "input",
                        field: "RJJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "上期结存（元）",
                        type: "input",
                        field: "SQJC",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "总发放人数",
                        type: "input",
                        field: "ZFFRS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "收款人姓名",
                        type: "input",
                        field: "SKRXX",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "申请金额（元）",
                        type: "input",
                        field: "SQJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "开户银行",
                        type: "input",
                        field: "KHYH",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "账号",
                        type: "input",
                        field: "ZH",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "申请类型",
                        type: "input",
                        field: "SQLX",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "申请时间",
                        type: "input",
                        field: "SQSJ",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "附件",
                        type: "upload",
                        field: "FJ",
                        readOnly: true,
                        labelWidth: 150
                    },{
                        label: "申请事由",
                        type: "textarea",
                        field: "SQSY",
                        readOnly: true,
                        labelWidth: 150
                    }
                ]
            },
            {
                name: "申请人员",
                tabText: "申请人员",
                // formatTabText: "[Name]",
                ismx: true,
                detail: [{
                        label: "AD账号",
                        field: "JobNumber",
                        type: "input"
                    },
                    {
                        label: "姓名",
                        field: "XM",
                        type: "input"
                    },

                ]
            }
        ]
    },

    专项费用申请单: {
        allSubmit: true,
        shortTitle: "专项费用申请单",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        config: [{
                name: "专项费用申请单（主表）", // 表单名称
                tabText: "专项费用申请单（主表）",
                shortTitle: "专项费用申请单",
                mainForm: true,
                notAuto: true,
                column: [{
                        label: "费用年度",
                        type: "input",
                        field: "YSND",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "人均金额（元/人）",
                        type: "input",
                        field: "RJJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "总发放人数",
                        type: "input",
                        field: "ZFFRS",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "收款人姓名",
                        type: "input",
                        field: "SKRXX",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "申请金额（元）",
                        type: "input",
                        field: "SQJE",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "开户银行",
                        type: "input",
                        field: "KHYH",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "账号",
                        type: "input",
                        field: "ZH",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "申请类型",
                        type: "input",
                        field: "SQLX",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "申请时间",
                        type: "input",
                        field: "SQSJ",
                        readOnly: true,
                        labelWidth: 150
                    }, {
                        label: "附件",
                        type: "upload",
                        field: "FJ",
                        readOnly: true,
                        labelWidth: 150
                    },{
                        label: "申请事由",
                        type: "textarea",
                        field: "SQSY",
                        readOnly: true,
                        labelWidth: 150
                    }
                ]
            },
            {
                name: "申请人员",
                tabText: "申请人员",
                // formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表

                ],
                detail: [{
                        label: "AD账号",
                        field: "JobNumber",
                        type: "input"
                    },
                    {
                        label: "姓名",
                        field: "XM",
                        type: "input"
                    },

                ]
            }
        ]
    },

    办事处费用季度: {
        allSubmit: true,
        shortTitle: "办事处费用季度",
        isActive: true,
        generalAction: true,
        okNeedIdea: true,
        config: [{
            name: "办事处费用季度（主表）", // 表单名称
            tabText: "办事处费用季度（主表）",
            shortTitle: "办事处费用季度",
            mainForm: true,
            notAuto: true,
            column: [{
                    label: "费用年度",
                    type: "input",
                    field: "YSND",
                    readOnly: true,
                    labelWidth: 150
                },
                {
                    label: "费用季度",
                    type: "select",
                    field: "YSJD",
                    labelWidth: 150,
                    option: [{ // 下拉数据
                        label: '第一季度',
                        value: '1',
                        default: true // 默认选中
                    }, { // 下拉数据
                        label: '第二季度',
                        value: '2',
                    }, { // 下拉数据
                        label: '第三季度',
                        value: '3',
                    }, { // 下拉数据
                        label: '第四季度',
                        value: '4',
                    }],
                },
                {
                    label: "总金额（元）",
                    type: "input",
                    field: "SQJE",
                    readOnly: true,
                    labelWidth: 150
                },
                 {
                    label: "类型",
                    type: "input",
                    field: "SQLX",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "事由",
                    type: "input",
                    field: "SQSY",
                    readOnly: true,
                    labelWidth: 150,
                    col:24
                },{
                    label: "创建时间",
                    type: "input",
                    field: "SQSJ",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "创建人",
                    type: "input",
                    field: "CreateUserName",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "附件",
                    type: "upload",
                    field: "FJ",
                    readOnly: true,
                    labelWidth: 150
                }
            ]
        }]
    },
    会员七类特种病补助: {
        allSubmit: true,
        shortTitle: "会员七类特种疾病补助申请",
        onlyStr: "会员七类特种病补助",
        addRushTitle: "补助申请审批加催",
        button: {
            submit: { // 提交的方法
                text: "提交",
                action: "/MobileApis/DataHandler.ashx?action=SaveData",
                success: {
                    popup: "success",
                    action: "back"
                },
                // if: "this.newForm == true"
            }
        },
        status: { // 获取单子状态的方法
            action: "/MobileApis/WelfareHandler.ashx?action=GetSubsidyApplyStatus",
            param: {
                shortTitle: "会员七类特种疾病补助申请",
                type: "会员七类特种病补助"
            }
        },
        config: [{
                name: "会员七类特种病补助",
                tabText: "会员七类特种病补助申请表",
                action: {},
                mainForm: true,
                shortTitle: "会员七类特种疾病补助申请",
                column: [{
                        label: "申请人",
                        type: "input", // 控件类型
                        field: "SQR", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        autoScan: "user",
                        readOnly: true,
                        placeholder: "请输入"
                    },
                    {
                        label: "补助类型",
                        type: "select", // 控件类型
                        field: "TypeName", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        option: [{
                            label: "会员七类特种病补助",
                            value: "会员七类特种病补助",
                            default: true
                        }],
                        readOnly: true,
                        placeholder: "请输入"
                    },
                    {
                        label: "性别",
                        type: "select",
                        field: "XB",
                        required: true,
                        autoScan: "userSex",
                        option: [{
                            label: "男",
                            value: "男",
                        }, {
                            label: "女",
                            value: "女",
                        }],
                    },
                    {
                        label: "年龄",
                        type: "number",
                        max: 70,
                        required: true,
                        field: "NL",
                        int: true,
                        autoScan: "userAge",
                    },
                    {
                        label: "部门",
                        type: "input", // 控件类型
                        field: "BM", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入部门", // 没有填写的提示
                        readOnly: true,
                        placeholder: "请输入",
                        autoScan: "bumen"
                    },
                    {
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "GH", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        readOnly: true,
                        autoScan: "userCode"
                    },
                    {
                        label: "手机号码",
                        type: "input", // 控件类型
                        field: "SJHM", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入手机号码", // 没有填写的提示
                        placeholder: "请输入",
                        rulesMessage: "请输入正确的手机号码",
                        rules: "tel",
                        autoScan: "userTel",
                        formatType: "tel"
                    },
                    {
                        type: "checkbox",
                        field: "JBZL",
                        label: "疾病种类",
                        min: 1,
                        async: {
                            action: "/MobileApis/DataHandler.ashx?action=GetFormDataList",
                            param: {
                                shortTitle: "疾病维护表",
                                orderby:[{columnName:"sort",sortType:""}],
                                filter: [{key:"ISEnable",value:true,sqlOperator:"EN"}],
                                start: 1,
                                limit: 999
                            },
                            showField: "JBZL"
                        },
                        // option: [{
                        //     label: '慢性肾衰竭（尿毒症）',
                        //     field: 'MXSSJ'
                        //   },
                        //   {
                        //     label: '恶性肿瘤',
                        //     field: 'EXZL'
                        //   },
                        //   {
                        //     label: '再生障碍性贫血',
                        //     field: 'ZSZAXPX'
                        //   },
                        //   {
                        //     label: '颅内肿瘤手术',
                        //     field: 'LNZLSS'
                        //   },
                        //   {
                        //     label: '急性/亚急性/中晚期慢性重型肝炎',
                        //     field: 'ZXGY'
                        //   },
                        //   {
                        //     label: '心脏瓣膜置换手术',
                        //     field: 'XZZHSS'
                        //   },
                        //   {
                        //     label: '冠状动脉旁路手术',
                        //     field: 'GZDMSS'
                        //   },
                        // ]
                    },
                    {
                        label: "证明材料",
                        type: "upload",
                        field: "Files",
                        required: true,
                        requiredMessage: "请上传证明材料",
                        max: 10,
                        watermark: true
                    },
                    {
                        label: "申请人开户银行",
                        type: "input", // 控件类型
                        field: "SQRKHYH", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入申请人开户银行", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "银行账号",
                        type: "input", // 控件类型
                        field: "YHZH", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入银行账号", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "确诊时间",
                        type: "date", // 控件类型
                        field: "EventDate", // 字段名
                        required: true
                    },
                    {
                        label: "疾病描述及申请理由",
                        type: "textarea", // 控件类型
                        field: "JBSQLY", // 字段名
                        row: 4,
                        required: true, // 是否必填
                        requiredMessage: "请输入疾病描述及申请理由", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    
                ]

            }

        ]
    },

    会员直系亲属重大疾病补助: {
        allSubmit: true,
        shortTitle: "补助申请表",
        onlyStr: "会员直系亲属重大疾病补助",
        addRushTitle: "补助申请审批加催",
        button: {
            submit: { // 提交的方法
                text: "提交",
                action: "/MobileApis/DataHandler.ashx?action=SaveData",
                success: {
                    popup: "success",
                    action: "back"
                },
                // if: "this.newForm == true"
            }
        },
        status: { // 获取单子状态的方法
            action: "/MobileApis/WelfareHandler.ashx?action=GetSubsidyApplyStatus",
            param: {
                shortTitle: "补助申请表",
                type: "会员直系亲属重大疾病补助"
            }
        },
        config: [{
                name: "会员直系亲属重大疾病补助",
                tabText: "会员直系亲属重大疾病补助申请表",
                action: {},
                mainForm: true,
                shortTitle: "补助申请表",
                column: [{
                        label: "申请人",
                        type: "input", // 控件类型
                        field: "MemberName", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        autoScan: "user",
                        placeholder: "请输入",
                        readOnly: true
                    },
                    {
                        label: "申请日期",
                        type: "date", // 控件类型
                        field: "CreateTime", // 字段名
                        autoScan: "today",
                        readOnly: true,
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "直系亲属姓名",
                        type: "select", // 控件类型
                        field: "RelationName", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入直系亲属姓名", // 没有填写的提示
                        async: {
                            action: "/MobileApis/MemberApplyHandler.ashx?action=GetFamilyInfo",
                            showField: "Name",
                            field: "Name"
                        },
                        linkChange: {
                            "RelationType": "RelationType"
                        }
                    },

                    {
                        label: "补助类型",
                        type: "select", // 控件类型
                        field: "TypeName", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        option: [{
                            label: "会员直系亲属重大疾病补助",
                            value: "会员直系亲属重大疾病补助",
                            default: true
                        }],
                        readOnly: true,
                        placeholder: "请输入"
                    },
                    {
                        label: "双方关系",
                        type: "select", // 控件类型
                        field: "RelationType", // 字段名
                        required: true, // 是否必填
                        option: [{
                                label: "父母",
                                value: "父母",
                            },
                            {
                                label: "配偶父母",
                                value: "配偶父母",
                            }, {
                                label: "配偶",
                                value: "配偶",
                            }, {
                                label: "子女",
                                value: "子女",
                            }
                        ],
                        requiredMessage: "请选择双方关系", // 没有填写的提示
                        placeholder: "请选择"
                    },
                    {
                        label: "部门",
                        type: "input", // 控件类型
                        field: "Department", // 字段名
                        autoScan: "bumen",
                        readOnly: true,
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "MemberCode", // 字段名
                        readOnly: true,
                        autoScan: "userCode",
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "联系人",
                        type: "input", // 控件类型
                        field: "ContactPerson", // 字段名
                        autoScan: "user"
                    },
                    {
                        label: "手机号码",
                        type: "input", // 控件类型
                        field: "Mobile", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入",
                        rules: "tel",
                        rulesMessage: "请输入正确的手机号码",
                        autoScan: "userTel",
                        formatType: "tel"
                    },
                    {
                        label: "证明材料",
                        type: "upload",
                        field: "Files",
                        required: true,
                        requiredMessage: "请上传证明材料",
                        max: 10,
                        watermark: true
                    },
                    {
                        label: "申请人开户银行",
                        type: "input", // 控件类型
                        field: "BankName", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入申请人开户银行", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "银行账号",
                        type: "input", // 控件类型
                        field: "BankAccount", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入银行账号", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "疾病描述及申请理由",
                        type: "textarea", // 控件类型
                        field: "ApplyContent", // 字段名
                        row: 4,
                        required: true, // 是否必填
                        requiredMessage: "请输入疾病描述及申请理由", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "确诊时间",
                        type: "date", // 控件类型
                        field: "EventDate", // 字段名
                        required: true
                    }
                ]

            }

        ]
    },

    上级工会临时帮困: {
        allSubmit: true,
        shortTitle: "帮困金（临补）申请表",
        addRushTitle: "补助申请审批加催",
        button: {
            submit: { // 提交的方法
                text: "提交",
                action: "/MobileApis/DataHandler.ashx?action=SaveData",
                success: {
                    popup: "success",
                    action: "back"
                },
                if: "this.newForm == true"
            }
        },
        status: { // 获取单子状态的方法
            action: "/MobileApis/WelfareHandler.ashx?action=GetSubsidyApplyStatus",
            param: {
                shortTitle: "帮困金（临补）申请表",
                type: "上级工会临时帮困"
            }
        },
        config: [{
                name: "上海市医药工会帮困金（临补）申请表",
                tabText: "上海市医药工会帮困金（临补）申请表 ",
                action: {},
                mainForm: true,
                shortTitle: "帮困金（临补）申请表",
                column: [{
                        label: "申请日期",
                        type: "date", // 控件类型
                        field: "SQRQ", // 字段名
                        autoScan: "today",
                        readOnly: true,
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        placeholder: "请输入"
                    },
                    {
                        label: "编号",
                        type: "input", // 控件类型
                        field: "BH", // 字段名
                        autoScan: "autoCode",
                        readOnly: true,
                        hide: true
                    },
                    {
                        label: "职工姓名",
                        type: "input", // 控件类型
                        field: "ZGXM", // 字段名
                        required: true, // 是否必填
                        requiredMessage: "请输入", // 没有填写的提示
                        readOnly: true,
                        autoScan: "user",
                        placeholder: "请输入"
                    },
                    {
                        label: "性别",
                        type: "input",
                        autoScan: "userSex",
                        field: "XB",
                        readOnly: true,
                        placeholder: "请输入",
                        required: true,
                    },
                    {
                        label: "政治面貌",
                        type: "select", // 控件类型
                        required: true,
                        placeholder: "请选择政治面貌",
                        // option: SELECT_MAP["zhengzhimianmao"],
                        requiredMessage: "请选择政治面貌",
                        autoScan: "userZzmm",
                        field: "ZZMM", // 字段名
                    },
                    {
                        label: "证件号码",
                        type: "input", // 控件类型
                        required: true,
                        readOnly: true,
                        autoScan: "idCard",
                        field: "SFZHM", // 字段名
                        placeholder: "请输入...",
                        rules: "idCard",
                        rulesMessage: "请输入正确的证件号码码",
                        formatType: "idCard",

                    },
                    {
                        label: "证明材料",
                        type: "upload",
                        field: "Files",
                        required: true,
                        requiredMessage: "请上传证明材料",
                        max: 10,
                        watermark: true
                    },
                    {
                        label: "家庭地址",
                        type: "input", // 控件类型
                        autoScan: "homeAddr",
                        field: "JTDZ", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "家庭电话",
                        type: "input", // 控件类型
                        field: "JTDH", // 字段名
                        autoScan: "homeAddr",
                        placeholder: "请输入..."
                    },
                    {
                        label: "工作单位",
                        type: "input", // 控件类型
                        field: "GZDW", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "单位电话",
                        type: "input", // 控件类型
                        field: "DWDH", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "月收入",
                        type: "input", // 控件类型
                        field: "YSR", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "是否在岗",
                        type: "select", // 控件类型
                        option: [{
                                label: '在岗',
                                value: '在岗',
                                default: true
                            },
                            {
                                label: '长病假',
                                value: '长病假',
                            },
                            {
                                label: '协保',
                                value: '协保',
                            },
                            {
                                label: '待岗',
                                value: '待岗',
                            },
                            {
                                label: '待退',
                                value: '待退',
                            },
                            {
                                label: '其他',
                                value: '其他',
                            },
                        ],
                        field: "SFZG", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "是否单亲",
                        type: "select", // 控件类型
                        option: [{
                                label: '否',
                                value: '否',
                                default: true
                            },
                            {
                                label: '是',
                                value: '是',
                            },

                        ],
                        field: "SFDQ", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "单亲状态",
                        type: "select", // 控件类型
                        option: [{
                                label: '',
                                value: '',
                                default: true
                            }, {
                                label: '病故',
                                value: '病故',
                            },
                            {
                                label: '离异',
                                value: '离异',
                            },
                        ],
                        if: "this.form.SFDQ == '是'",
                        field: "DQZT", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "每月民政救助金(户)",
                        field: "MZJZJ",
                        type: "input"
                    },
                    {
                        type: "split",
                        text: "配偶信息"
                    },
                    // {
                    //   type: "text",
                    //   text: "以上信息来自CHRIS系统，如有差错请联系HR Operation在CHRIS中直接修改，修改后数据第二天自动更新到工会网站。",
                    //   style: {
                    //     color: "#FE9A18",
                    //     'font-size': '12px'
                    //   }
                    // },
                    {
                        label: "配偶姓名",
                        type: "input", // 控件类型
                        field: "POXM", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "配偶性别",
                        type: "select",
                        field: "POXB",
                        option: [{
                                label: '男',
                                value: '男'
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ],
                        placeholder: "请选择..."
                    },
                    {
                        label: "配偶证件号码",
                        type: "input",
                        field: "POSFZ", // 字段名
                        placeholder: "请输入...",
                        rulesMessage: "请输入正确的证件号码码",
                        rules: "idCard",
                        formatType: "idCard"
                    },
                    {
                        label: "配偶工作单位",
                        type: "input",
                        field: "POGZDW", // 字段名
                        placeholder: "请输入...",
                    },
                    {
                        label: "配偶月收入",
                        type: "input",
                        field: "POYSR", // 字段名
                        placeholder: "请输入...",
                    },
                    {
                        label: "每月低保金（人）",
                        type: "input",
                        field: "PODBJ", // 字段名
                        placeholder: "请输入...",
                    },
                    {
                        label: "是否在岗",
                        type: "select", // 控件类型
                        option: [{
                                label: '',
                                value: '',
                                default: true
                            }, {
                                label: '在岗',
                                value: '在岗',
                            },
                            {
                                label: '长病假',
                                value: '长病假',
                            },
                            {
                                label: '协保',
                                value: '协保',
                            },
                            {
                                label: '待岗',
                                value: '待岗',
                            },
                            {
                                label: '待退',
                                value: '待退',
                            },
                            {
                                label: '其他',
                                value: '其他',
                            },
                        ],
                        field: "POSFZG", // 字段名
                        placeholder: "请选择..."
                    },
                    {
                        label: "再就业月收入",
                        type: "input",
                        field: "POZJYYSR", // 字段名
                        placeholder: "请输入...",
                    },
                    {
                        label: "家庭是否有此情况",
                        type: "checkbox",
                        field: "jtsfycqk",
                        option: [{
                            label: "子女国外就读",
                            field: 'ZVGWJD'
                        }, {
                            label: "投资股票、债券、基金",
                            field: 'GPJJ'
                        }, {
                            label: "养宠物",
                            field: 'YCW'
                        }, {
                            label: "拥有私人汽车、第二住宅并出租",
                            field: 'SRQC'
                        }],
                    },
                    {
                        type: "textarea",
                        label: "其他困难",
                        field: "QTKN"
                    }
                ]
            },
            {
                name: "子女就读情况",
                tabText: "子女就读情况",
                shortTitle: "帮困金（临补）申请表_子女就读情况",
                // boxTopText: "信息内容用于活动、福利、票务、保险使用",
                boxAdd: true,
                defaultBoxNum: 0,
                column: [{
                        label: "子女姓名",
                        type: "input",
                        field: "ZVXM", // 字段名
                        placeholder: "请输入...",
                        required: true,
                        requiredMessage: "请输入",
                    },
                    {
                        label: "性别",
                        type: "select",
                        option: [{
                                label: '男',
                                value: '男'
                            },
                            {
                                label: '女',
                                value: '女'
                            },
                        ],
                        field: "XB", // 字段名
                        placeholder: "请选择...",
                        required: true,
                        requiredMessage: "请输入",
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "SFZH", // 字段名
                        placeholder: "请输入...",
                        required: true,
                        requiredMessage: "请输入",
                        rules: "idCard",
                        rulesMessage: "请输入正确的证件号码码",
                        formatType: "idCard"
                    },
                    {
                        label: "就读学校",
                        type: "input",
                        field: "JDXX", // 字段名
                        placeholder: "请输入...",
                        required: true,
                        requiredMessage: "请输入",
                    },
                    {
                        label: "年级",
                        type: "input",
                        field: "NJ", // 字段名
                        placeholder: "请输入...",
                    },
                    {
                        label: "学制",
                        type: "input",
                        field: "XZ", // 字段名
                        placeholder: "请输入..."
                    },
                    {
                        label: "每月低保金（人）",
                        type: "input",
                        field: "MYDBJ", // 字段名
                        placeholder: "请输入...",
                    },
                ],
            },
            {
                name: "其他人员情况",
                tabText: "其他人员情况",
                shortTitle: "帮困金（临补）申请表_其他人员情况",
                // boxTopText: "信息内容用于活动、福利、票务、保险使用",
                boxAdd: true,
                defaultBoxNum: 0,
                column: [{
                        label: "姓名",
                        type: "input",
                        field: "XM", // 字段名
                        placeholder: "请输入...",
                        required: true,
                        requiredMessage: "请输入",
                    },
                    {
                        label: "称谓",
                        type: "input",
                        field: "CW", // 字段名
                        placeholder: "请输入...",
                        required: true,
                        requiredMessage: "请输入",
                    },
                    {
                        label: "证件号码",
                        type: "input",
                        field: "SFZH", // 字段名
                        placeholder: "请输入...",
                        required: true,
                        requiredMessage: "请输入",
                        rules: "idCard",
                        rulesMessage: "请输入正确的证件号码码",
                        formatType: "idCard"
                    },
                    {
                        label: "工作单位",
                        type: "input",
                        field: "GZDW", // 字段名
                        placeholder: "请输入...",
                        required: true,
                        requiredMessage: "请输入",
                    },
                    {
                        label: "月收入",
                        type: "input",
                        field: "YSR", // 字段名
                        placeholder: "请输入...",
                    },
                    {
                        label: "每月低保金（人）",
                        type: "input",
                        field: "MYDBJ", // 字段名
                        placeholder: "请输入...",
                    },
                ],
            },
            {
                name: "健康状态",
                tabText: "健康状态",
                shortTitle: "帮困金（临补）申请表_健康状态",
                // boxTopText: "信息内容用于活动、福利、票务、保险使用",
                boxAdd: true,
                defaultBoxNum: 0,
                column: [{
                        label: "关系",
                        type: "select",
                        field: "RYXX", // 字段名
                        required: true,
                        option: [{
                                label: "本人",
                                value: "本人"
                            },
                            {
                                label: "配偶",
                                value: "配偶"
                            },
                            {
                                label: "子女",
                                value: "子女"
                            },
                        ]
                    },
                    {
                        label: "患主要疾病（√）",
                        type: "checkbox",
                        option: [{
                                label: '尿毒症',
                                field: 'NDZ'
                            },
                            {
                                label: '精神病',
                                field: 'JSB'
                            },
                            {
                                label: '乳腺癌',
                                field: 'RXA'
                            },
                            {
                                label: '肺癌',
                                field: 'FA'
                            },
                            {
                                label: '胃癌',
                                field: 'WA'
                            },
                            {
                                label: '肝癌',
                                field: 'GA'
                            },
                            {
                                label: '肠癌',
                                field: 'CA'
                            },
                            {
                                label: '肾炎',
                                field: 'SA'
                            },
                            {
                                label: '心脏病',
                                field: 'XZB'
                            },
                            {
                                label: '糖尿病',
                                field: 'TNB'
                            },
                            {
                                label: '红斑狼疮',
                                field: 'HBLC'
                            },
                            {
                                label: '脑部疾病',
                                field: 'NBJB'
                            },
                            {
                                label: '残疾-失明',
                                field: 'SM'
                            },
                            {
                                label: '残疾-肢残',
                                field: 'ZC'
                            },
                            {
                                label: '残疾-聋哑',
                                field: 'LY'
                            },
                            {
                                label: '残疾-低能',
                                field: 'DN'
                            },
                        ]
                    },
                    {
                        label: "其他疾病",
                        type: "input",
                        field: "HQTBQTX", // 字段名
                        placeholder: "请输入...",
                    }
                ],
            }
        ]
    },

    会员转入转出: {
        allSubmit: true,
        shortTitle: "小组转移",
        title: "会员转入",
        config: [{
                name: "会员转入",
                tabText: "会员转入",
                action: {},
                mainForm: true,
                shortTitle: "小组转移",
                column: [{
                        label: "AD账号",
                        type: "input", // 控件类型
                        field: "MemberCode", // 字段名
                        readOnly: true
                    },
                    {
                        label: "姓名",
                        type: "input", // 控件类型
                        field: "MemberName", // 字段名
                        readOnly: true
                    }, {
                        label: "部门",
                        type: "input", // 控件类型
                        field: "Depart", // 字段名
                        readOnly: true
                    }, {
                        label: "分站",
                        type: "input", // 控件类型
                        field: "Substation", // 字段名
                        readOnly: true
                    }, {
                        label: "原有小组",
                        type: "input", // 控件类型
                        field: "CurrentGroup", // 字段名
                        readOnly: true
                    }, {
                        label: "目标小组",
                        type: "input", // 控件类型
                        field: "TargetGroup", // 字段名
                        readOnly: true
                    },
                    {
                        label: "目标分站",
                        type: "input", // 控件类型
                        field: "StationName", // 字段名
                        readOnly: true
                    },
                    {
                        label: "转移理由",
                        type: "input", // 控件类型
                        field: "Reason", // 字段名
                        readOnly: true
                    },

                    {
                        label: "原因",
                        type: "textarea", // 控件类型
                        field: "Remark", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "",
                        type: "input", // 控件类型
                        field: "GroupManager", // 字段名
                        readOnly: true,
                        hide: true
                    },
                    {
                        label: "",
                        type: "input", // 控件类型
                        field: "TargetGroupManager", // 字段名
                        readOnly: true,
                        hide: true
                    },
                    {
                        label: "转移时间",
                        type: "input", // 控件类型
                        field: "ChangeDate", // 字段名
                        readOnly: true,
                        hide: true
                    },
                    {
                        label: "提交时间",
                        type: "input", // 控件类型
                        field: "CreateTime", // 字段名
                        readOnly: true
                    },
                    {
                        label: "会员工会",
                        type: "input", // 控件类型
                        field: "CompanyName", // 字段名
                        readOnly: true,
                        hide: true
                    },
                    {
                        label: "转移类型",
                        type: "input", // 控件类型
                        field: "ChangeType", // 字段名
                        readOnly: true,
                        hide: true
                    },
                ]
            }

        ]
    },

    活动分享发布: {
        allSubmit: true,
        shortTitle: "活动分享发布",
        config: [{
                name: "活动分享发布",
                tabText: "活动分享发布",
                action: {},
                mainForm: true,
                shortTitle: "活动分享发布",
                column: [{
                        label: "分享标题",
                        type: "input", // 控件类型
                        field: "Title", // 字段名
                        readOnly: true
                    },
                    {
                        label: "活动类型",
                        type: "input", // 控件类型
                        field: "ActivityType", // 字段名
                        readOnly: true
                    }, {
                        label: "封面图片",
                        type: "upload", // 控件类型
                        field: "FmImgUrl", // 字段名
                        readOnly: true
                    }, {
                        label: "分享照片",
                        type: "upload", // 控件类型
                        field: "ImgUrl", // 字段名
                        readOnly: true
                    }, {
                        label: "所属活动",
                        type: "input", // 控件类型
                        field: "ActivityId", // 字段名
                        readOnly: true
                    }, {
                        label: "发送活动通知",
                        type: "input", // 控件类型
                        field: "wechatNotify", // 字段名
                        readOnly: true
                    },
                    {
                        label: "活动分享摘要",
                        type: "input", // 控件类型
                        field: "Summary", // 字段名
                        readOnly: true
                    },

                    {
                        label: "允许评论",
                        type: "input", // 控件类型
                        field: "IsCommentAllow", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "分享说明",
                        type: "input", // 控件类型
                        field: "ContentType", // 字段名
                        readOnly: true,

                    },
                    {
                        label: "发布时间",
                        type: "input", // 控件类型
                        field: "CreateTime", // 字段名
                        readOnly: true,

                    },
                    {
                        label: "发布人",
                        type: "input", // 控件类型
                        field: "CreateUserName", // 字段名
                        readOnly: true,

                    },
                ]
            }

        ]
    },

    评论信息表: {
        allSubmit: true,
        shortTitle: "评论信息表",
        config: [{
                name: "评论信息表",
                tabText: "评论信息表",
                action: {},
                mainForm: true,
                shortTitle: "评论信息表",
                column: [{
                        label: "评论人",
                        type: "input", // 控件类型
                        field: "MemberName", // 字段名
                        readOnly: true
                    },
                    {
                        label: "评论人账号",
                        type: "input", // 控件类型
                        field: "MemberCode", // 字段名
                        readOnly: true
                    }, {
                        label: "评论时间",
                        type: "input", // 控件类型
                        field: "CreateTime", // 字段名
                        readOnly: true
                    }, {
                        label: "评论状态",
                        type: "input", // 控件类型
                        field: "CommentStatus", // 字段名
                        readOnly: true
                    }, {
                        label: "评论内容",
                        type: "input", // 控件类型
                        field: "Comment", // 字段名
                        readOnly: true
                    }, {
                        label: "备注",
                        type: "input", // 控件类型
                        field: "Remark", // 字段名
                        readOnly: true
                    },
                    {
                        label: "敏感词",
                        type: "input", // 控件类型
                        field: "Words", // 字段名
                        readOnly: true
                    },
                ]
            }

        ]
    },

    会员补助填写: {
        allSubmit: true,
        shortTitle: "会员补助填写",
        button: {
            submit: { // 提交的方法
                text: "提交",
                action: "/MobileApis/DataHandler.ashx?action=SaveData",
                success: {
                    popup: "success",
                    action: "back"
                },
                if: "this.newForm == true"
            }
        },
        status: { // 获取单子状态的方法
            action: "/MobileApis/WelfareHandler.ashx?action=GetSubsidyApplyStatus",
            param: {
                type: "watch",
                shortTitle: "会员补助填写",
            }
        },
        config: [{
            name: "会员补助填写",
            tabText: "会员补助填写",
            action: {},
            mainForm: true,
            shortTitle: "会员补助填写",
            column: [{
                    label: "姓名",
                    type: "input", // 控件类型
                    field: "MemberName", // 字段名
                    readOnly: true,
                    autoScan: "user"
                },
                {
                    label: "账号",
                    type: "input", // 控件类型
                    field: "MemberCode", // 字段名
                    readOnly: true,
                    autoScan: "userCode"
                },
                {
                    label: "填写时间",
                    type: "date", // 控件类型
                    field: "fillInDate", // 字段名
                    readOnly: true,
                    autoScan: "today"
                },
                {
                    label: "填写类型",
                    type: "select", // 控件类型
                    field: "fillInType", // 字段名
                    autoScan: "watch",
                    // option: [
                    //   {label: "享基本保障给付申请审批表", value: "享基本保障给付申请审批表", default: true},
                    //   {label: "因工伤/亡及非因工去世帮困补助", value: "因工伤/亡及非因工去世帮困补助"},
                    //   {label: "爱助计划帮扶金申请表", value: "爱助计划帮扶金申请表"},
                    //   {label: "医药工会帮困金（临补）申请表", value: "医药工会帮困金（临补）申请表"},
                    //   {label: "直系亲属重大疾病补助申请", value: "直系亲属重大疾病补助申请"},
                    // ],
                    async: {
                        action: "/MobileApis/WelfareHandler.ashx?action=GetSubsidyType",
                        showField: "Name",
                        param: {
                            type: '线上记录'
                        }
                    },
                    readOnly: true
                },
                {
                    label: "确诊时间",
                    type: "date", // 控件类型
                    field: "EventDate", // 字段名
                    required: true
                },
                {
                    label: "图片资料",
                    type: "upload", // 控件类型
                    field: "FaceImage", // 字段名
                    max: 10,
                    required: true,
                    watermark: true,
                    onlyUploadImg: true
                },
                {
                    label: "原因",
                    type: "textarea", // 控件类型
                    field: "Remark", // 字段名
                    row: 8,
                    required: true
                },
                
            ]
        }]
    },
    其他: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
            name: "其他（主表）", // 表单名称
            tabText: "其他（主表）",
            shortTitle: "活动信息表",
            mainForm: true,
            notAuto: true,
            column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN.filter((item) => item.label != "报名开始时间" && item.label != "报名结束时间")
        }, ]
    },

    社区分享: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
            name: "社区分享（主表）", // 表单名称
            tabText: "社区分享（主表）",
            shortTitle: "活动信息表",
            mainForm: true,
            notAuto: true,
            column: [...GENERAL_ACTIVE_MAIN_CONFIG_COLUMN, {
                    label: "分享方式",
                    type: "checkbox", // 控件类型
                    field: "suibian", // 字段名
                    readOnly: true,
                    option: [{
                            label: '图片',
                            field: 'shareTypeImage'
                        },
                        {
                            label: '视频',
                            field: 'shareTypeVideo'
                        }
                    ]
                }, {
                    label: "上传限制图片数量最多（张）",
                    type: "input", // 控件类型
                    field: "MaxPictures", // 字段名
                    readOnly: true,
                }, {
                    label: "上传限制视频文件最大（M）",
                    type: "input", // 控件类型
                    field: "VideoUploadMax", // 字段名
                    readOnly: true,
                }, {
                    label: "允许评论",
                    type: "input", // 控件类型
                    field: "AllowReply", // 字段名
                    readOnly: true,
                },
                {
                    label: "允许点赞",
                    type: "input", // 控件类型
                    field: "AllowLikes", // 字段名
                    readOnly: true,
                },
                {
                    label: "开放日期",
                    type: "input", // 控件类型
                    field: "OpeningDate", // 字段名
                    readOnly: true,
                },
                {
                    label: "开放时间",
                    type: "input", // 控件类型
                    field: "OpeningTime", // 字段名
                    readOnly: true,
                },
            ]
        }, ]
    },

    线上调研: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
            name: "线上调研（主表）", // 表单名称
            tabText: "线上调研（主表）",
            shortTitle: "活动信息表",
            mainForm: true,
            notAuto: true,
            column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
        }, ]
    },

    课程教学: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
            name: "课程教学（主表）", // 表单名称
            tabText: "课程教学（主表）",
            shortTitle: "活动信息表",
            mainForm: true,
            notAuto: true,
            column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
        }, ]
    },

    健康走: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
            name: "健康走（主表）", // 表单名称
            tabText: "健康走（主表）",
            shortTitle: "活动信息表",
            mainForm: true,
            notAuto: true,
            column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
        }, ]
    },

    健身课程: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "健身课程（主表）", // 表单名称
                tabText: "健身课程（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: [...(CLONE_GENERAL_ACTIVE_MAIN_CONFIG_COLUMN.filter((item) => item.label != '受邀人员' && item.label != '提醒选项' && item.label != '家属提醒内容')).map((item) => {
                    if (item.label == '报名对象') {
                        var a = [];
                        item.option.map((s) => {
                            s.label == '会员' || s.label == '预备会员' ? a.push(s) : null
                        })
                        item.option = a;
                    }
                    return item;
                }), {
                    label: "每周最多预约课程数",
                    type: "input", // 控件类型
                    field: "MaxLimit", // 字段名
                    readOnly: true,
                    labelWidth: 150
                }]
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    // {
                    //   label: "课程地点",
                    //   type: "input",
                    //   field: "Name",
                    //   readOnly: true,
                    // },
                ],
                detail: [{
                        label: "星期",
                        field: "CourseDate",
                        type: "day"
                    },
                    {
                        label: "课程日期",
                        field: "CourseDate",
                        type: "input",
                        momentFormat: "YYYY-MM-DD"
                    },
                    {
                        label: "时间",
                        field: "CourseTime",
                        type: "input"
                    },
                    {
                        label: "课程",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "课程地点",
                        field: "PlaceName",
                        type: "input"
                    },
                    {
                        label: "签到时间",
                        field: "SignInTime1",
                        type: "input",
                        labelWidth: 60
                    },
                    {
                        label: "签退时间",
                        field: "SignOutTime1",
                        type: "input",
                        labelWidth: 60
                    },
                    {
                        label: "R币奖励",
                        field: "Amount",
                        type: "input"
                    },
                    {
                        label: "人数上限",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "是否允许候补",
                        field: "HouBuStatus",
                        type: "input"
                    },
                    {
                        label: "候补上限人数",
                        field: "HouBuLimit",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },
                    {
                        label: "候补确认时间(小时)",
                        field: "HouBuConfirmTime",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },
                    {
                        label: "教练姓名",
                        field: "TeacherName",
                        type: "input"
                    },
                    {
                        label: "教练手机号",
                        field: "TeacherAccount",
                        type: "tel"
                    },
                ]
            }
        ]
    },

    '通用活动-启用代金券': {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "票务活动（主表）", // 表单名称
                tabText: "票务活动（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: [...GENERAL_ACTIVE_MAIN_CONFIG_COLUMN,
                    {
                        label: "报名选择限制-最少",
                        type: "input", // 控件类型
                        field: "MinLimit", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "报名选择限制-最多",
                        type: "input", // 控件类型
                        field: "MaxLimit", // 字段名
                        readOnly: true,
                    },
                ]
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "分组名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    },
                    {
                        label: "组内报名数量限制-最多",
                        type: "input",
                        field: "MaxLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "组内报名数量限制-最少",
                        type: "input",
                        field: "MinLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                ],
                detail: [{
                        label: "场次说明",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "单人费用",
                        field: "Price",
                        type: "input"
                    },
                    {
                        label: "票数上限",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "单人最多票数",
                        field: "SignUpLimit",
                        type: "input"
                    },
                    {
                        label: "是否开启代金券",
                        field: "UserCoupon",
                        type: "input",
                        if: "item.UserCoupon != '否' && item.UserCoupon != 0"
                    },
                    {
                        label: "代金券最多使用比例(%)",
                        field: "CouponRate",
                        type: "input"
                    },

                ]
            }
        ]
    },

    '通用活动-禁用代金券': {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "票务活动（主表）", // 表单名称
                tabText: "票务活动（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: [...GENERAL_ACTIVE_MAIN_CONFIG_COLUMN,
                    {
                        label: "报名选择限制-最少",
                        type: "input", // 控件类型
                        field: "MinLimit", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "报名选择限制-最多",
                        type: "input", // 控件类型
                        field: "MaxLimit", // 字段名
                        readOnly: true,
                    },
                ]
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "分组名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    },
                    {
                        label: "组内报名数量限制-最多",
                        type: "input",
                        field: "MaxLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "组内报名数量限制-最少",
                        type: "input",
                        field: "MinLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                ],
                detail: [{
                        label: "场次说明",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "单人费用",
                        field: "Price",
                        type: "input"
                    },
                    {
                        label: "票数上限",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "单人最多票数",
                        field: "SignUpLimit",
                        type: "input"
                    },
                    {
                        label: "是否开启代金券",
                        field: "UserCoupon",
                        type: "input",
                        if: "item.UserCoupon != '否' && item.UserCoupon != 0"
                    },
                    {
                        label: "代金券最多使用比例(%)",
                        field: "CouponRate",
                        type: "input"
                    },

                ]
            }
        ]
    },
    旅游出行: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "旅游出行（主表）", // 表单名称
                tabText: "旅游出行（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: [...GENERAL_ACTIVE_MAIN_CONFIG_COLUMN, {
                    label: "报名选择限制-最少",
                    type: "input",
                    field: "MinLimit",
                    readOnly: true,
                    labelWidth: 150
                }, {
                    label: "报名选择限制-最多",
                    type: "input",
                    field: "MaxLimit",
                    readOnly: true,
                    labelWidth: 150
                }]
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "分组名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    },
                    {
                        label: "组内报名数量限制-最多",
                        type: "input",
                        field: "MaxLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "组内报名数量限制-最少",
                        type: "input",
                        field: "MinLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                ],
                detail: [{
                        label: "说明内容",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "说明图片",
                        field: "DesImage",
                        type: "upload"
                    },
                    {
                        label: "单人费用",
                        field: "Price",
                        type: "input"
                    },
                    {
                        label: "报名数量限制",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "单人报名数量上限",
                        field: "SignUpLimit",
                        type: "input"
                    },
                    {
                        label: "是否开启代金券",
                        field: "UserCoupon",
                        type: "input"
                    },
                    {
                        label: "代金券最多使用比例(%)",
                        field: "CouponRate",
                        type: "input",
                        if: "item.UserCoupon != '否' && item.UserCoupon != 0"
                    },
                    {
                        label: "是否允许候补",
                        field: "HouBuStatus",
                        type: "input"
                    },
                    {
                        label: "候补上限人数",
                        field: "HouBuLimit",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },


                ]
            }
        ]
    },

    团建活动: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "团建活动（主表）", // 表单名称
                tabText: "团建活动（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
            },
            {
                name: "相关信息",
                tabText: "相关信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "活动名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    },
                    {
                        label: "组内报名数量限制-最多",
                        type: "input",
                        field: "MaxLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "组内报名数量限制-最少",
                        type: "input",
                        field: "MinLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                ],
                detail: [{
                        label: "报名人数上限",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "是否启用候补",
                        field: "HouBuStatus",
                        type: "input"
                    },
                    {
                        label: "候补人数上限",
                        field: "HouBuLimit",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },
                    {
                        label: "候补确认时间",
                        field: "HouBuConfirmTime",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },
                ]
            }
        ]
    },

    兴趣俱乐部活动: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "兴趣俱乐部活动（主表）", // 表单名称
                tabText: "兴趣俱乐部活动（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "分组名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    },
                    {
                        label: "组内报名数量限制-最多",
                        type: "input",
                        field: "MaxLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "组内报名数量限制-最少",
                        type: "input",
                        field: "MinLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                ],
                detail: [{
                        label: "说明",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "说明图片",
                        field: "DesImage",
                        type: "upload"
                    },
                    {
                        label: "单人费用",
                        field: "Price",
                        type: "input"
                    },
                    {
                        label: "报名人数上限",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "单人最多报名人数",
                        field: "SignUpLimit",
                        type: "input"
                    },
                    {
                        label: "是否开启代金券",
                        field: "UserCoupon",
                        type: "input"
                    },
                    {
                        label: "代金券最多使用比例(%)",
                        field: "CouponRate",
                        type: "input",
                        if: "item.UserCoupon != '否' && item.UserCoupon != 0"
                    },
                    {
                        label: "是否允许候补",
                        field: "HouBuStatus",
                        type: "input"
                    },
                    {
                        label: "候补上限人数",
                        field: "HouBuLimit",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },


                ]
            }
        ]
    },

    票务活动: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "票务活动（主表）", // 表单名称
                tabText: "票务活动（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: [...GENERAL_ACTIVE_MAIN_CONFIG_COLUMN,
                    {
                        label: "报名选择限制-最少",
                        type: "input", // 控件类型
                        field: "MinLimit", // 字段名
                        readOnly: true,
                    },
                    {
                        label: "报名选择限制-最多",
                        type: "input", // 控件类型
                        field: "MaxLimit", // 字段名
                        readOnly: true,
                    },
                ]
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "分组名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    },
                    {
                        label: "组内报名数量限制-最多",
                        type: "input",
                        field: "MaxLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                    {
                        label: "组内报名数量限制-最少",
                        type: "input",
                        field: "MinLimit",
                        readOnly: true,
                        labelWidth: 150
                    },
                ],
                detail: [{
                        label: "场次说明",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "单人费用",
                        field: "Price",
                        type: "input"
                    },
                    {
                        label: "票数上限",
                        field: "MaxLimit",
                        type: "input"
                    },
                    {
                        label: "单人最多票数",
                        field: "SignUpLimit",
                        type: "input"
                    },
                    {
                        label: "是否开启代金券",
                        field: "UserCoupon",
                        type: "input",
                        if: "item.UserCoupon != '否' && item.UserCoupon != 0"
                    },
                    {
                        label: "代金券最多使用比例(%)",
                        field: "CouponRate",
                        type: "input"
                    },

                ]
            }
        ]
    },

    联谊活动: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "联谊活动（主表）", // 表单名称
                tabText: "联谊活动（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "分组名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    },
                    // {
                    //   label: "组内报名数量限制-最多",
                    //   type: "input",
                    //   field: "MaxLimit",
                    //   readOnly: true,
                    //   labelWidth: 150
                    // },
                    // {
                    //   label: "组内报名数量限制-最少",
                    //   type: "input",
                    //   field: "MinLimit",
                    //   readOnly: true,
                    //   labelWidth: 150
                    // },
                ],
                detail: [{
                        label: "说明内容",
                        field: "LineName",
                        type: "input"
                    },
                    {
                        label: "单人费用",
                        field: "Price",
                        type: "input"
                    },
                    {
                        label: "报名数量限制",
                        field: "MaxLimit",
                        type: "input"
                    },
                    // {
                    //   label: "单人报名数量上限",
                    //   field: "SignUpLimit",
                    //   type: "input"
                    // },
                    {
                        label: "是否开启代金券",
                        field: "UserCoupon",
                        type: "input"
                    },
                    {
                        label: "代金券最多使用比例(%)",
                        field: "CouponRate",
                        type: "input",
                        if: "item.UserCoupon != '否' && item.UserCoupon != 0"
                    },
                    {
                        label: "是否允许候补",
                        field: "HouBuStatus",
                        type: "input"
                    },
                    {
                        label: "候补上限人数",
                        field: "HouBuLimit",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },

                    {
                        label: "候补确认时间",
                        field: "HouBuConfirmTime",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },

                ]
            }
        ]
    },

    会议培训: {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
                name: "会议培训（主表）", // 表单名称
                tabText: "会议培训（主表）",
                shortTitle: "活动信息表",
                mainForm: true,
                notAuto: true,
                column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
            },
            {
                name: "分组信息",
                tabText: "分组信息",
                formatTabText: "[Name]",
                ismx: true,
                column: [ // 指主表
                    {
                        label: "分组名称",
                        type: "input",
                        field: "Name",
                        readOnly: true,
                    }
                ],
                detail: [
                    // {
                    //   label: "单人报名数量上限",
                    //   field: "SignUpLimit",
                    //   type: "input"
                    // },
                    {
                        label: "报名人数上限",
                        field: "MaxLimit",
                        type: "input"
                    },

                    {
                        label: "是否允许候补",
                        field: "HouBuStatus",
                        type: "input"
                    },
                    {
                        label: "候补人数上限",
                        field: "HouBuLimit",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },

                    {
                        label: "候补确认时间",
                        field: "HouBuConfirmTime",
                        type: "input",
                        if: "item.HouBuStatus != 0"
                    },
                    {
                        label: "是否允许未报名签到",
                        field: "IsAllowSign",
                        type: "input"
                    },
                    // {
                    //   label: "课程日期",
                    //   field: "CourseDate",
                    //   type: "input",
                    // },
                    {
                        label: "签到时间",
                        field: "SignInTime1",
                        type: "input",
                        labelWidth: 60
                    },
                    {
                        label: "签退时间",
                        field: "SignOutTime",
                        type: "input",
                        labelWidth: 60
                    },
                ]
            }
        ]
    },

    "开工饭/年夜饭": {
        allSubmit: true,
        shortTitle: "活动信息表",
        isActive: true,
        config: [{
            name: "开工饭/年夜饭（主表）", // 表单名称
            tabText: "开工饭/年夜饭（主表）",
            shortTitle: "活动信息表",
            mainForm: true,
            notAuto: true,
            column: GENERAL_ACTIVE_MAIN_CONFIG_COLUMN
        }, ]
    },
}

export default {
    OPTION_JF_FORM,
}